import PropTypes from "prop-types";
import React, { Component } from "react";
import {
  Box,
  Chip,
  Collapse,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Select,
  TextField,
  Tooltip,
  Typography
} from "@material-ui/core";
import {
  Mic as MicIcon,
  Description as DescriptionIcon,
  HeadsetMic as HeadsetMicIcon,
  Delete as DeleteIcon,
  RecordVoiceOver as RecordVoiceOverIcon,
  AssignmentTurnedIn as AssignmentTurnedInIcon,
  Check as CheckIcon,
  DeleteOutline as DeleteOutlineIcon,
  DoneAll as DoneAllIcon,
  ChevronLeft as ChevronLeftIcon,
  ChevronRight as ChevronRightIcon,
  LastPage as LastPageIcon,
  ExpandMore as ExpandMoreIcon,
  ExpandLess as ExpandLessIcon,
  Event as EventIcon,
  GraphicEq as GraphicEqIcon,
  ArrowDropDown as ArrowDropDownIcon,
  MoreVert as MoreVertIcon
} from "@material-ui/icons";
import styled from "styled-components";
import { withRouter } from "react-router-dom";
import { withAlert } from "react-alert";
import { withTranslation } from "react-i18next";
import moment from "moment";
import i18n from "../../utils/i18n";
import Group from "../../waybee-ui/Group";
import Heading from "../../waybee-ui/Heading";
import BackButton from "../../components/BackButton";
import Button from "../../waybee-ui/Button";
import Dialog from "../../waybee-ui/Dialog/Dialog";
import {
  ACTIONS_FILTER,
  approveAtaDraft,
  canApproveAtaDraft,
  canShowEncaminhamentos,
  getAtaStatusLabel,
  countActionsByFilter,
  ensureEncaminhamentosReleased,
  filterActionsByStatus,
  mergeFilteredActionEdits,
  releasePendingActions,
  resolveAtaStatus,
  syncActionStatusesFromLaterMeetings,
  deleteAtaDraftRemote,
  downloadAudioPlaceholder,
  downloadTranscript,
  fetchAtaDraftFromServer,
  getAtaDraft,
  updateAtaDraft
} from "./ataDraftStore";
import { deleteAtaAudio, resolveAtaAudioPlayback } from "./ataAudioStore";
import AtaAudioPlayer from "./AtaAudioPlayer";
import AtaActionsGrouped from "./AtaActionsGrouped";
import AtaParticipantsChip from "./AtaParticipantsChip";
import AtaStatusChip from "./ataStatusChip";
import { applyAssigneeFromConfirmedTurn } from "./actionGroups";
import SmartMinutesService from "../../services/SmartMinutesService";
import TeacherService from "../../services/TeacherService";
import StudentService from "../../services/StudentService";
import isClassDiaryDemo from "../../demo/isClassDiaryDemo";
import {
  buildDemoStaffForClass,
  enrichStudentWithGuardians,
  mapTeacherToStaff
} from "./demoParticipants";
import {
  listVoiceProfileLog,
  logVoiceLinkEvent,
  summarizeVoiceProfiles
} from "./voiceProfileLog";
import {
  applyTurnPersonToAta,
  applyTurnPersonToMany,
  applyPersonSelectionToPendingTurns,
  applyTurnVoiceSuggestions,
  applyVoiceTraitsFromConfirm,
  attachDiarizedTimestamps,
  attachEstimatedTimestamps,
  attachMockVoiceSamples,
  buildSpeakersFromAta,
  cleanTurnBodyForDisplay,
  countPendingTurnsForSpeaker,
  displaySpeakerForTurn,
  ensureAtaSpeakers,
  expandTurnIds,
  findActiveTurn,
  findSpeakerForTurn,
  formatParticipantRole,
  formatResponsibilityLabel,
  formatSpeakerMetaLine,
  formatTurnTime,
  formatVoiceConfidence,
  getConfirmSpeakerRun,
  getPersonResponsibility,
  getTurnLink,
  listPendingTurnsInRun,
  listPendingDisplayTurnsInRun,
  mergeConsecutiveSameSpeakerTurns,
  ADD_PARTICIPANT_VALUE,
  ALT_VOICE_SCORE,
  addPersonToAta,
  guestRoleOptions,
  listAddableParticipants,
  listPersonOptions,
  listPendingSamplesBySpeaker,
  normalizeAttributedTranscript,
  normalizeNameKey,
  parseTranscriptTurns,
  PRESELECT_VOICE_SCORE,
  speakersSummary,
  suggestGuestFromDetectedName,
  syncSpeakerSamplesFromTurnLinks,
  transcriptHasSpeakerTurns,
  voiceConfidenceStyle
} from "./speakers";
import { theme as appTheme } from "../../assets/theme/StyledTheme";

const TRANSCRIPT_PAGE_SIZE = 8;
const TRANSCRIPT_FILTER_ALL = "all";
const TRANSCRIPT_FILTER_PENDING = "pending";
const TRANSCRIPT_FILTER_CONFIRMED = "confirmed";

const TitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
`;

const TitleCluster = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  min-width: 0;
  flex: 1 1 auto;
`;

const SectionCompactMeta = styled.div`
  margin-top: 8px;
  font-size: 13px;
  line-height: 1.4;
  color: #607681;
`;

/** Cabeçalho colapsável discreto (ex.: reunião anterior). */
const SubSectionToggle = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  width: 100%;
  margin: 0 0 8px;
  padding: 6px 0;
  border: 0;
  background: transparent;
  cursor: pointer;
  text-align: left;
  font: inherit;
  color: #546e7a;

  &:hover {
    color: ${({ theme }) => theme.color.primary.dark};
  }

  &:focus {
    outline: none;
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.color.primary.main};
    outline-offset: 2px;
    border-radius: 4px;
  }

  .MuiSvgIcon-root {
    font-size: 20px;
    color: #90a4ae;
    flex: 0 0 auto;
  }

  &:hover .MuiSvgIcon-root {
    color: ${({ theme }) => theme.color.primary.dark};
  }
`;

const SubSectionToggleLabel = styled.span`
  flex: 1 1 auto;
  min-width: 0;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-transform: uppercase;
`;

const SubSectionCount = styled.span`
  flex: 0 0 auto;
  font-size: 12px;
  font-weight: 600;
  color: #90a4ae;
  letter-spacing: 0;
  text-transform: none;
`;

const ActionsSubhead = styled(Typography)`
  && {
    margin: 0 0 8px;
    font-size: 13px;
    font-weight: 700;
    letter-spacing: 0.02em;
    text-transform: uppercase;
    color: #546e7a;
  }
`;

const ActionsFilterRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin: 0 0 14px;
`;

const ActionsFilterChip = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  height: 28px;
  padding: 0 10px;
  border-radius: 999px;
  border: 1px solid
    ${({ $active, theme }) =>
      $active ? theme.color.primary.main : "rgba(0, 48, 59, 0.1)"};
  background: ${({ $active, theme }) =>
    $active ? theme.color.primary.light : "transparent"};
  color: ${({ $active, theme }) =>
    $active ? theme.color.primary.dark : "#78909c"};
  font-size: 12px;
  font-weight: ${({ $active }) => ($active ? 600 : 500)};
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;

  &:hover {
    border-color: ${({ theme }) => theme.color.primary.main};
    color: ${({ theme }) => theme.color.primary.dark};
    background: ${({ theme }) => theme.color.primary.light};
  }

  .count {
    font-variant-numeric: tabular-nums;
    opacity: 0.85;
  }
`;

const TranscriptFilterChip = styled(Chip)`
  && {
    cursor: pointer;
    font-weight: ${({ $active }) => ($active ? 600 : 500)};
    box-shadow: ${({ $active, theme }) =>
      $active ? `0 0 0 2px ${theme.color.primary.light}` : "none"};
  }
`;

/** Ícone de seção — fundo mint suave, sem glow. */
const SectionIcon = styled.div`
  flex: 0 0 auto;
  width: 36px;
  height: 36px;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => theme.color.primary.light};
  border: 1px solid ${({ theme }) => theme.color.primary.main};
  color: ${({ theme }) => theme.color.primary.dark};

  .MuiSvgIcon-root {
    font-size: 20px;
    color: inherit;
  }
`;

const Meta = styled(Typography)`
  && {
    color: #607681;
    font-size: 14px;
  }
`;

const TranscriptBox = styled.pre`
  margin: 0;
  padding: 14px 16px;
  background: ${({ $flash, theme }) =>
    $flash ? theme.color.primary.light : "#f7fafb"};
  border: 1px solid
    ${({ $flash, theme }) => ($flash ? theme.color.primary.main : "#e8eef0")};
  border-radius: 8px;
  white-space: pre-wrap;
  word-break: break-word;
  font-family: inherit;
  font-size: 14px;
  line-height: 1.5;
  color: #37474f;
  transition: background 0.35s ease, border-color 0.35s ease;
`;

const TranscriptTurns = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 4px;
  border-radius: 8px;
  background: ${({ $flash, theme }) =>
    $flash ? theme.color.primary.light : "transparent"};
  transition: background 0.35s ease;
`;

const TurnCard = styled.div`
  border: 1px solid
    ${({ $active, theme }) => ($active ? theme.color.primary.main : "#e8eef0")};
  border-radius: 10px;
  padding: 12px 14px;
  background: ${({ $active, theme }) =>
    $active ? theme.color.primary.light : "#fff"};
  box-shadow: ${({ $active, theme }) =>
    $active ? `0 0 0 1px ${theme.color.primary.light}` : "none"};
  transition: background 0.2s ease, border-color 0.2s ease;
  cursor: pointer;

  &:hover {
    border-color: ${({ theme }) => theme.color.primary.main};
    background: ${({ theme }) => theme.color.primary.light};
  }
`;

const LiveCaption = styled.div`
  margin-top: 12px;
  padding: 12px 14px;
  border-radius: 10px;
  border: 1px solid ${({ theme }) => `${theme.color.primary.main}40`};
  background: linear-gradient(
    180deg,
    ${({ theme }) => `${theme.color.primary.light}28`} 0%,
    #fff 36%
  );
`;

const LiveCaptionHead = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 6px;
`;

const LiveCaptionText = styled(Typography)`
  && {
    font-size: 14px;
    line-height: 1.55;
    color: #37474f;
    white-space: pre-wrap;
    word-break: break-word;
  }
`;

const TurnSpeech = styled(Typography)`
  && {
    margin-top: 10px;
    font-size: 14px;
    line-height: 1.55;
    color: #37474f;
    white-space: pre-wrap;
    word-break: break-word;
  }
`;

const SpeakerMetaLine = styled(Typography)`
  && {
    margin-top: 2px;
    font-size: 12px;
    line-height: 1.35;
    color: #78909c;
  }
`;

const TurnIdentity = styled.div`
  min-width: 0;
  flex: 1 1 160px;
`;

const SpeakerNameBtn = styled.button`
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 1px;
  margin: 0;
  padding: 4px 8px 4px 6px;
  margin-left: -6px;
  border: 1px dashed transparent;
  border-radius: 8px;
  background: transparent;
  cursor: pointer;
  text-align: left;
  font: inherit;
  color: inherit;
  max-width: 100%;
  transition: background 0.15s ease, border-color 0.15s ease;

  &:hover {
    background: ${({ theme }) => theme.color.primary.light};
    border-color: ${({ theme }) => theme.color.primary.main}55;
  }

  &:focus {
    outline: none;
    background: ${({ theme }) => theme.color.primary.light};
    border-color: ${({ theme }) => theme.color.primary.main};
  }

  .speaker-name-row {
    display: inline-flex;
    align-items: center;
    gap: 2px;
    max-width: 100%;
  }

  strong {
    font-size: 14px;
    line-height: 1.3;
    color: ${({ theme }) => theme.color.primary.dark};
    border-bottom: 1px dotted ${({ theme }) => theme.color.primary.main}88;
  }

  .speaker-name-chevron {
    flex: 0 0 auto;
    font-size: 20px;
    color: ${({ theme }) => theme.color.primary.main};
    opacity: 0.85;
  }
`;

const TurnControlsBar = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  width: 100%;
  margin-top: 8px;
  padding: ${({ $compact }) => ($compact ? "4px 0" : "8px 10px")};
  border-radius: 8px;
  background: ${({ $compact }) => ($compact ? "transparent" : "#f7fafb")};
  border: ${({ $compact }) => ($compact ? "none" : "1px solid #e8eef0")};
  box-sizing: border-box;

  .turn-select {
    flex: 1 1 200px;
    min-width: 160px;
  }

  .turn-select .MuiOutlinedInput-root {
    min-height: ${({ $compact }) => ($compact ? "36px" : "44px")};
  }

  .turn-select .MuiSelect-select {
    display: flex;
    align-items: center;
    padding-top: 6px;
    padding-bottom: 6px;
  }

  @media (max-width: 720px) {
    justify-content: flex-end;
  }
`;

const CompactConfirmRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;
  margin-top: 6px;
`;

/** Nome + papel no seletor de participante (menu e valor fechado). */
const PersonOptionLabel = styled.span`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 1px;
  line-height: 1.25;
  max-width: 100%;
  overflow: hidden;
`;

const PersonOptionName = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: #263238;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
`;

const PersonOptionMeta = styled.span`
  font-size: 12px;
  font-weight: 400;
  color: #90a4ae;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
`;

const SelectHintItem = styled.span`
  display: block;
  font-family: inherit;
  font-style: normal;
  font-size: 13px;
  font-weight: 500;
  color: #78909c;
  line-height: 1.3;
`;

const SelectAddItem = styled.span`
  display: block;
  font-family: inherit;
  font-style: normal;
  font-size: 13px;
  font-weight: 600;
  color: ${({ theme }) => theme.color.primary.dark};
  line-height: 1.3;
`;

/** Tag sutil no canto superior do card (confiança da voz). */
const ConfidenceTag = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  flex: 0 0 auto;
  margin-left: auto;
  padding: 3px 8px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  letter-spacing: 0.02em;
  line-height: 1;
  color: ${({ $color }) => $color || "#5f7a72"};
  background: ${({ $bg, theme }) => $bg || theme.color.primary.light};
  border: 1px solid
    ${({ $border, theme }) => $border || theme.color.primary.main};

  .MuiSvgIcon-root {
    font-size: 13px;
    opacity: 0.85;
  }
`;

const VoiceProgressWrap = styled.div`
  margin: 10px 0 4px;
`;

const VoiceProgressMeta = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  margin-bottom: 6px;
  font-size: 12px;
  color: #607681;

  strong {
    color: ${({ theme }) => theme.color.primary.dark};
    font-variant-numeric: tabular-nums;
  }
`;

const VoiceProgressTrack = styled.div`
  height: 8px;
  border-radius: 999px;
  background: #e8eef0;
  overflow: hidden;
`;

const VoiceProgressFill = styled.div`
  height: 100%;
  width: ${({ $pct }) => `${Math.max(0, Math.min(100, $pct))}%`};
  background: linear-gradient(
    90deg,
    ${({ theme }) => theme.color.primary.dark} 0%,
    ${({ theme }) => theme.color.primary.main} 100%
  );
  transition: width 0.25s ease;
`;

const SampleList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  max-height: 220px;
  overflow-y: auto;
  margin-top: 8px;
  padding-right: 2px;
`;

const SampleRow = styled.div`
  display: grid;
  grid-template-columns: auto 28px 28px minmax(0, 1fr);
  align-items: center;
  column-gap: 2px;
  min-width: 0;
  width: 100%;
  min-height: 32px;

  > *:first-child {
    display: flex;
    align-items: center;
  }

  .MuiIconButton-root {
    width: 28px;
    height: 28px;
    padding: 2px;
  }
`;

const SampleButtonFallback = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 30px;
  min-width: 54px;
  padding: 0 10px;
  border-radius: 999px;
  border: 1px solid #cfd8dc;
  background: #fafafa;
  color: #607681;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
`;

const SampleLegend = styled.div`
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  line-height: 1.2;

  span {
    display: inline-block;
    font-size: 12px;
    color: #607681;
    padding-left: 4px;
  }

  &:hover span {
    animation: sample-legend-marquee 8s linear infinite;
  }

  @keyframes sample-legend-marquee {
    0% {
      transform: translateX(0);
    }
    100% {
      transform: translateX(-100%);
    }
  }
`;

const TurnNav = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 2px;
  margin-left: auto;
`;

const TurnNavIndex = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 2px;
  height: 28px;
  padding: 0 8px;
  border-radius: 999px;
  border: 1px solid ${({ theme }) => theme.color.primary.main};
  background: #fff;
  color: ${({ theme }) => theme.color.primary.dark};
  font-size: 12px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  cursor: pointer;

  &:hover {
    background: ${({ theme }) => theme.color.primary.light};
  }

  span {
    cursor: pointer;
    padding: 0 1px;
  }
`;

const TimeChip = styled.button`
  display: inline-flex;
  align-items: center;
  height: 24px;
  padding: 0 8px;
  border-radius: 999px;
  border: 1px solid ${({ theme }) => theme.color.primary.main};
  background: ${({ theme }) => theme.color.primary.light};
  color: ${({ theme }) => theme.color.primary.dark};
  font-size: 12px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  cursor: pointer;

  &:hover {
    background: ${({ theme }) => theme.color.primary.light};
  }
`;

const PagerRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  margin-top: 12px;
`;

const SpeakerCard = styled.div`
  border: 1px solid
    ${({ $unlinked }) => ($unlinked ? "rgba(237, 108, 2, 0.45)" : "#e8eef0")};
  border-radius: 10px;
  padding: 12px 14px;
  margin-bottom: 10px;
  background: ${({ $unlinked }) => ($unlinked ? "#fffaf3" : "#fff")};
  transition: background 0.15s ease, border-color 0.15s ease;

  &:hover {
    background: ${({ $unlinked, theme }) =>
      $unlinked ? "#fff3e0" : theme.color.primary.light};
    border-color: ${({ $unlinked, theme }) =>
      $unlinked ? "rgba(237, 108, 2, 0.6)" : theme.color.primary.main};
  }
`;

const SpeakerCardBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: stretch;
`;

const SpeakerCardTop = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
`;

const SpeakerSamplesToggle = styled.button`
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  gap: 2px;
  margin: 0;
  padding: 2px 6px;
  border: 0;
  border-radius: 999px;
  background: transparent;
  color: #78909c;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.2;
  cursor: pointer;
  white-space: nowrap;

  .MuiSvgIcon-root {
    font-size: 16px;
  }

  &:hover {
    color: ${({ theme }) => theme.color.primary.dark};
    background: ${({ theme }) => theme.color.primary.light};
  }
`;

const SpeakerInfo = styled.div`
  min-width: 0;
  flex: 1 1 auto;

  .speaker-name {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .speaker-meta {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
`;

/**
 * Mobile: hero → áudio (destaque) → encaminhamentos → transcrição.
 * Desktop: coluna esquerda (header/áudio/transcrição) + side sticky.
 */
const DetailLayout = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;

  @media (min-width: 960px) {
    display: grid;
    grid-template-columns: ${({ $hasSide }) =>
      $hasSide ? "minmax(0, 3fr) minmax(320px, 2fr)" : "minmax(0, 1fr)"};
    grid-template-areas: ${({ $hasSide, $hasAudio }) => {
      if ($hasSide && $hasAudio) {
        return `"header side"
           "audio side"
           "main side"`;
      }
      if ($hasSide) {
        return `"header side"
           "main side"`;
      }
      if ($hasAudio) {
        return `"header"
           "audio"
           "main"`;
      }
      return `"header"
           "main"`;
    }};
    align-items: start;
  }
`;

const HeaderCol = styled.div`
  order: 1;

  @media (min-width: 960px) {
    grid-area: header;
    order: unset;
  }
`;

const AudioCol = styled.div`
  min-width: 0;
  order: 2;

  @media (min-width: 960px) {
    grid-area: audio;
    order: unset;
  }
`;

const HeroCard = styled.div`
  position: relative;
  overflow: hidden;
  border-radius: 14px;
  border: 1px solid ${({ theme }) => theme.color.primary.main};
  background: radial-gradient(
      110% 80% at 0% 0%,
      ${({ theme }) => theme.color.primary.light} 0%,
      transparent 52%
    ),
    linear-gradient(145deg, #f7fbfa 0%, #ffffff 55%, #f8fafb 100%);
  padding: 20px 22px 16px;
`;

const HeroTop = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
`;

const HeroBrandRow = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
  min-width: 0;
  flex: 1 1 200px;
`;

const HeroBrand = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  min-width: 0;
  flex: 1 1 auto;
`;

const HeroControls = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
  flex: 0 1 auto;
  max-width: 100%;
  /* Mantém à direita mesmo quando o flex-wrap quebra a linha do título */
  margin-left: auto;

  @media (max-width: 720px) {
    width: 100%;
    margin-left: 0;
  }
`;

const HeroActionRail = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  max-width: 100%;

  @media (max-width: 720px) {
    width: 100%;
    justify-content: flex-end;
  }
`;

const GhostAction = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 36px;
  padding: 0 12px;
  border-radius: 999px;
  border: 1px solid
    ${({ disabled, $danger, $active, theme }) => {
      if (disabled) return "#d7dee2";
      if ($danger) return "rgba(198, 40, 40, 0.35)";
      if ($active) return theme.color.primary.dark;
      return theme.color.primary.main;
    }};
  background: ${({ disabled, $active, theme }) => {
    if (disabled) return "#f5f7f8";
    if ($active) return theme.color.primary.dark;
    return "#fff";
  }};
  color: ${({ disabled, $danger, $active, theme }) => {
    if (disabled) return "#9aa7ad";
    if ($active) return "#fff";
    if ($danger) return "#c62828";
    return theme.color.primary.dark;
  }};
  font-size: 13px;
  font-weight: 600;
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;

  svg {
    font-size: 18px;
  }

  &:hover:not(:disabled) {
    background: ${({ $danger, theme }) =>
      $danger ? "#c62828" : theme.color.primary.dark};
    border-color: ${({ $danger, theme }) =>
      $danger ? "#c62828" : theme.color.primary.dark};
    color: #fff;

    .action-count {
      background: rgba(255, 255, 255, 0.22);
      color: #fff;
    }
  }
`;

const ActionCountBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  color: ${({ theme }) => theme.color.primary.dark};
  background: ${({ theme }) => theme.color.primary.light};
`;

const HeroIcon = styled(SectionIcon)`
  width: 44px;
  height: 44px;
  border-radius: 12px;

  .MuiSvgIcon-root {
    font-size: 24px;
  }
`;

const HeroTitleBlock = styled.div`
  min-width: 0;

  h1 {
    margin: 0;
    font-size: 22px;
    line-height: 1.25;
    font-weight: 700;
    color: ${({ theme }) => theme.color.primary.dark};
    word-break: break-word;
  }
`;

const HeroEyebrow = styled.div`
  margin-bottom: 4px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: ${({ theme }) => theme.color.primary.dark};
`;

/** Toggle de minimizar — só mobile (desktop ignora). */
const MobileCollapseBtn = styled.button`
  display: none;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  margin: 0;
  padding: 0;
  border: 0;
  border-radius: 999px;
  background: transparent;
  color: #78909c;
  cursor: pointer;

  @media (max-width: 720px) {
    display: inline-flex;
  }

  &:hover {
    background: ${({ theme }) => theme.color.primary.light};
    color: ${({ theme }) => theme.color.primary.dark};
  }
`;

const HeroCompactMeta = styled.div`
  margin-top: 8px;
  font-size: 13px;
  line-height: 1.4;
  color: #607681;
`;

const MetaStrip = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px 18px;
  margin-top: 14px;
`;

const MetaItem = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: #546e7a;
  min-width: 0;

  .MuiSvgIcon-root {
    flex: 0 0 auto;
    font-size: 16px;
    color: ${({ theme }) => theme.color.primary.dark};
  }

  span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

const MainCol = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-width: 0;
  order: 4;

  @media (min-width: 960px) {
    grid-area: main;
    order: unset;
  }
`;

const SideCol = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-width: 0;
  order: 3;

  @media (min-width: 960px) {
    grid-area: side;
    order: unset;
    position: sticky;
    top: 16px;
    align-self: start;
    max-height: calc(100vh - 32px);
    overflow: auto;
  }
`;

class SmartMinutesDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ata: null,
      confirmDelete: false,
      deleteConfirmText: "",
      deletingAta: false,
      priorReviewsOpen: true,
      actionsFilter: ACTIONS_FILTER.OPEN,
      transcriptFlash: false,
      attributing: false,
      reloadingTranscript: false,
      audioDurationSec: null,
      transcriptQuery: "",
      transcriptFilter: TRANSCRIPT_FILTER_ALL,
      transcriptPage: 0,
      transcriptListStart: null,
      audioCurrentSec: 0,
      audioPlaying: false,
      activeTurnId: null,
      followAudio: false,
      // true = player principal toca a reunião inteira.
      // false = play da confirmação: só o fragmento (pausa no fim da fala).
      continuousPlayback: true,
      isMobileUi: false,
      // No mobile, hero começa minimizado para liberar a tela.
      heroCollapsed: true,
      // Seções: áudio aberto (destaque); demais fechadas até o usuário expandir.
      collapsedSections: {
        audio: false,
        actions: true,
        speakers: true,
        transcript: true
      },
      // Falas pendentes nos cards de participante: recolhidas por padrão.
      expandedSpeakerSamples: {},
      addParticipantOpen: false,
      addParticipantTurn: null,
      addParticipantPoolKey: "",
      addParticipantName: "",
      addParticipantRole: i18n.t("smartMinutes.role.coordination"),
      addParticipantLoading: false,
      speakerMenuAnchor: null,
      speakerMenuTurnId: null,
      heroMoreAnchor: null
    };
    this.transcriptFlashTimer = null;
    this.mobileMq = null;
    this.audioDurationUrl = null;
    this.turnCardRefs = {};
    this.ignoreFollowUntil = 0;
    this.segmentPauseForTurnId = null;
    // true = play veio do card de confirmação (só o fragmento; sync, sem race do setState)
    this.fragmentOnlyPlayback = false;
    // Enquanto o ▶ do card toca: não deixa o player principal avançar o card
    this.confirmClipLockTurnId = null;
    // Mantém a fala escolhida na navegação até o áudio acompanhar
    this.navPinTurnId = null;
    this.navPinTargetSec = null;
    this.navPinUntil = 0;
  }

  componentDidMount() {
    this.load();
    this.onDraftsUpdated = event => this.onAtaDraftsUpdated(event);
    window.addEventListener("ata-drafts-updated", this.onDraftsUpdated);
    this.onUserScrollIntent = () => this.pauseFollowFromUser();
    window.addEventListener("wheel", this.onUserScrollIntent, {
      passive: true
    });
    window.addEventListener("touchmove", this.onUserScrollIntent, {
      passive: true
    });
    window.addEventListener("ata-audio-user-play", this.onUserPlayAudio);
    if (typeof window !== "undefined" && window.matchMedia) {
      this.mobileMq = window.matchMedia("(max-width: 720px)");
      this.onMobileMqChange = () => {
        this.setState({ isMobileUi: !!this.mobileMq.matches });
      };
      this.onMobileMqChange();
      if (this.mobileMq.addEventListener) {
        this.mobileMq.addEventListener("change", this.onMobileMqChange);
      } else if (this.mobileMq.addListener) {
        this.mobileMq.addListener(this.onMobileMqChange);
      }
    }
    // Acompanhamento no DevTools: __ATA_VOICE_PROFILE_LOG__() / __ATA_VOICE_PROFILES__()
    if (typeof window !== "undefined") {
      /* eslint-disable no-underscore-dangle, no-console */
      window.__ATA_VOICE_PROFILE_LOG__ = listVoiceProfileLog;
      window.__ATA_VOICE_PROFILES__ = summarizeVoiceProfiles;
      console.info(
        "[SmartMinutes][voz] Lab: padrão acústico ainda NÃO é capturado.",
        "Ao vincular na transcrição, logamos voiceProfileKey.",
        "Helpers: __ATA_VOICE_PROFILE_LOG__(), __ATA_VOICE_PROFILES__()"
      );
      /* eslint-enable no-underscore-dangle, no-console */
    }
  }

  componentDidUpdate(prevProps) {
    const { match } = this.props;
    if (prevProps.match.params.ataId !== match.params.ataId) {
      this.load();
    }
  }

  componentWillUnmount() {
    window.removeEventListener("ata-drafts-updated", this.onDraftsUpdated);
    if (this.onUserScrollIntent) {
      window.removeEventListener("wheel", this.onUserScrollIntent);
      window.removeEventListener("touchmove", this.onUserScrollIntent);
      this.onUserScrollIntent = null;
    }
    window.removeEventListener("ata-audio-user-play", this.onUserPlayAudio);
    if (this.mobileMq && this.onMobileMqChange) {
      if (this.mobileMq.removeEventListener) {
        this.mobileMq.removeEventListener("change", this.onMobileMqChange);
      } else if (this.mobileMq.removeListener) {
        this.mobileMq.removeListener(this.onMobileMqChange);
      }
      this.mobileMq = null;
      this.onMobileMqChange = null;
    }
    if (this.transcriptFlashTimer) {
      clearTimeout(this.transcriptFlashTimer);
      this.transcriptFlashTimer = null;
    }
    this.revokeAudioDurationUrl();
  }

  getEntryModeLabel = entryMode => {
    const { t } = this.props;
    const key = `smartMinutes.entryMode.${entryMode}`;
    const label = t(key);
    return label === key ? entryMode : label;
  };

  toggleHeroCollapsed = () => {
    this.setState(prev => ({ heroCollapsed: !prev.heroCollapsed }));
  };

  isSectionMinimized = sectionKey => {
    const { isMobileUi, collapsedSections } = this.state;
    return isMobileUi && !!(collapsedSections && collapsedSections[sectionKey]);
  };

  toggleSectionCollapsed = sectionKey => {
    this.setState(prev => ({
      collapsedSections: {
        ...prev.collapsedSections,
        [sectionKey]: !prev.collapsedSections[sectionKey]
      }
    }));
  };

  expandSection = sectionKey => {
    this.setState(prev => ({
      collapsedSections: {
        ...prev.collapsedSections,
        [sectionKey]: false
      }
    }));
  };

  renderSectionCollapseBtn = (sectionKey, labels) => {
    const { t } = this.props;
    const minimized = this.isSectionMinimized(sectionKey);
    return (
      <MobileCollapseBtn
        type="button"
        aria-expanded={!minimized}
        aria-label={
          minimized
            ? labels.expand || t("smartMinutes.section.expand")
            : labels.collapse || t("smartMinutes.section.collapse")
        }
        onClick={() => this.toggleSectionCollapsed(sectionKey)}
      >
        {minimized ? <ExpandMoreIcon /> : <ExpandLessIcon />}
      </MobileCollapseBtn>
    );
  };

  pauseFollowFromUser = () => {
    const { followAudio } = this.state;
    if (!followAudio) return;
    // Evita desligar no scrollIntoView programático logo após mudar de turno
    if (Date.now() < this.ignoreFollowUntil) return;
    this.setState({ followAudio: false });
  };

  revokeAudioDurationUrl = () => {
    if (this.audioDurationUrl) {
      URL.revokeObjectURL(this.audioDurationUrl);
      this.audioDurationUrl = null;
    }
  };

  loadAudioDuration = async ata => {
    const canPlay = !!(
      ata &&
      (ata.hasLocalAudio || ata.hasRemoteAudio || ata.meetingId)
    );
    if (!canPlay) {
      this.setState({ audioDurationSec: null });
      return;
    }
    this.revokeAudioDurationUrl();
    try {
      const result = await resolveAtaAudioPlayback(ata);
      const url = result && result.url;
      if (!url) {
        this.setState({ audioDurationSec: null });
        return;
      }
      // Só revoga blob URLs; presign S3 não usa createObjectURL
      if (result.revoke !== false) {
        this.audioDurationUrl = url;
      }
      const audio = new Audio();
      audio.preload = "metadata";
      audio.src = url;
      await new Promise((resolve, reject) => {
        audio.onloadedmetadata = () => resolve();
        audio.onerror = () => reject(new Error("metadata"));
      });
      const duration = Number(audio.duration);
      this.setState({
        audioDurationSec: Number.isFinite(duration) ? duration : null
      });
    } catch (e) {
      this.setState({ audioDurationSec: null });
    }
  };

  /**
   * Atualização de draft enquanto a tela de detalhe está aberta.
   * Soft-refresh: NÃO zera activeTurnId (senão “Confirmar” perde o salto p/ próxima fala).
   */
  onAtaDraftsUpdated = event => {
    const detail = (event && event.detail) || {};
    const { match } = this.props;
    const ataId = match && match.params && match.params.ataId;
    if (!ataId) return;
    if (detail.cleared) {
      this.load();
      return;
    }
    if (detail.deleted && String(detail.id) === String(ataId)) {
      return;
    }
    if (detail.id && String(detail.id) !== String(ataId)) {
      return;
    }
    const local = getAtaDraft(ataId);
    if (!local) {
      this.load();
      return;
    }
    this.setState(prev => ({
      ata: local,
      activeTurnId:
        this.navPinTurnId && Date.now() < this.navPinUntil
          ? this.navPinTurnId
          : prev.activeTurnId,
      transcriptListStart: prev.transcriptListStart,
      transcriptPage: prev.transcriptPage,
      audioCurrentSec: prev.audioCurrentSec,
      continuousPlayback: prev.continuousPlayback,
      audioPlaying: prev.audioPlaying,
      followAudio: prev.followAudio
    }));
  };

  load = async () => {
    const { match } = this.props;
    const { ataId } = match.params;
    let ata = getAtaDraft(ataId);
    if (!isClassDiaryDemo()) {
      const remote = await fetchAtaDraftFromServer(ataId);
      if (remote) ata = remote;
    }
    if (ata) {
      const ensured = ensureAtaSpeakers(ata);
      const speakersChanged =
        ensured.speakers &&
        (!ata.speakers ||
          !ata.speakers.length ||
          ata.speakers.length !== ensured.speakers.length ||
          ata.speakers.some((s, i) => s.id !== ensured.speakers[i].id));
      const transcriptChanged =
        String(ensured.transcriptText || "") !==
        String(ata.transcriptText || "");
      if (speakersChanged || transcriptChanged) {
        // Persiste dedupe / turnos "Nome:" legados partidos por participante
        ata = updateAtaDraft(ata.id, {
          speakers: ensured.speakers,
          voicesLinked: ensured.voicesLinked,
          transcriptText: ensured.transcriptText
        });
      } else {
        ata = ensured;
      }
      // Labels Participante #N + amostras confirmadas
      const speakers = syncSpeakerSamplesFromTurnLinks(
        attachMockVoiceSamples(
          ata.speakers,
          ata.transcriptText,
          ata.diarizedSegments
        ),
        ata.turnLinks,
        ata.transcriptText
      );
      // Completa responsabilidade pedagógico/financeiro em atas antigas
      const students = (ata.students || []).map(s => ({
        ...s,
        guardians: (s.guardians || []).map(g => {
          if (g.responsibility) return g;
          const responsibility = getPersonResponsibility(
            ata,
            `guardian:${g.id}`,
            {
              name: g.name,
              role: g.role,
              relationship: g.relationship
            }
          );
          return responsibility ? { ...g, responsibility } : g;
        })
      }));
      ata = updateAtaDraft(ata.id, { speakers, students }) || {
        ...ata,
        speakers,
        students
      };
      // Libera encaminhamentos (+ fecha anteriores) sem botão manual
      ata = ensureEncaminhamentosReleased(ata.id) || ata;
      // Ata passada: reaplica done/parcial vindos do retorno
      ata = syncActionStatusesFromLaterMeetings(ata.id) || ata;
    }
    this.setState({ ata, transcriptPage: 0, activeTurnId: null }, () => {
      this.loadAudioDuration(ata);
    });
  };

  listPath = () => {
    const { match } = this.props;
    if (match.params.studentId) {
      return `/student/${match.params.studentId}/ata-inteligente`;
    }
    if (match.params.id) {
      return `/classes/${match.params.id}/ata-inteligente`;
    }
    return "/classes";
  };

  openSpeakerMenu = (event, turn) => {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }
    if (!turn) return;
    this.setState({
      speakerMenuAnchor: event.currentTarget,
      speakerMenuTurnId: turn.id
    });
  };

  closeSpeakerMenu = () => {
    this.setState({ speakerMenuAnchor: null, speakerMenuTurnId: null });
  };

  renderSpeakerSelectMenu = () => {
    const { t } = this.props;
    const { ata, speakerMenuAnchor, speakerMenuTurnId } = this.state;
    if (!ata || !speakerMenuAnchor || !speakerMenuTurnId) return null;
    const turn = this.getTimedTurns().find(x => x.id === speakerMenuTurnId);
    if (!turn) return null;

    const personOptions = listPersonOptions(ata);
    const speaker = findSpeakerForTurn(ata.speakers, turn.name);
    const turnLink = getTurnLink(ata, turn.id);
    const shown = displaySpeakerForTurn(turn, speaker, turnLink, ata);

    const resolveOptionId = (personId, personName) => {
      if (personId && personOptions.some(o => o.id === personId)) {
        return personId;
      }
      const key = normalizeNameKey(personName);
      if (!key) return null;
      const hit = personOptions.find(o => normalizeNameKey(o.name) === key);
      return hit ? hit.id : null;
    };

    let currentId = "";
    if (shown.validated) {
      currentId =
        resolveOptionId(shown.personId, shown.name) || shown.personId || "";
    } else {
      currentId =
        resolveOptionId(
          shown.suggestedPersonId,
          shown.suggestedPersonName || shown.name
        ) || "";
    }

    const personMetaLine = opt => {
      if (!opt) return "";
      const parts = [];
      if (opt.role) parts.push(formatParticipantRole(opt.role));
      const resp = formatResponsibilityLabel(opt.responsibility);
      if (resp) parts.push(resp);
      return parts.join(" · ");
    };

    return (
      <Menu
        anchorEl={speakerMenuAnchor}
        open={Boolean(speakerMenuAnchor)}
        onClose={this.closeSpeakerMenu}
        getContentAnchorEl={null}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        PaperProps={{ style: { maxHeight: 360, minWidth: 240 } }}
      >
        <MenuItem disabled dense>
          <SelectHintItem>
            {shown.validated
              ? t("smartMinutes.changeSpeakerHint")
              : t("smartMinutes.confirmOrChangeSpeaker")}
          </SelectHintItem>
        </MenuItem>
        {personOptions.map(opt => {
          const meta = personMetaLine(opt);
          const selected = opt.id === currentId;
          return (
            <MenuItem
              key={opt.id}
              selected={selected}
              onClick={() => {
                const wasValidated = !!shown.validated;
                const same = opt.id === currentId && wasValidated;
                if (same) {
                  this.closeSpeakerMenu();
                  return;
                }
                this.onLinkTurnSpeaker(turn, opt.id, {
                  // Já confirmada: só troca, sem pular para a próxima
                  advance: !wasValidated
                });
              }}
            >
              <PersonOptionLabel>
                <PersonOptionName>{opt.name}</PersonOptionName>
                {meta ? <PersonOptionMeta>{meta}</PersonOptionMeta> : null}
              </PersonOptionLabel>
            </MenuItem>
          );
        })}
        <MenuItem
          onClick={() => {
            this.closeSpeakerMenu();
            this.openAddParticipantDialog(turn);
          }}
        >
          <SelectAddItem>
            {t("smartMinutes.addParticipantEllipsis")}
          </SelectAddItem>
        </MenuItem>
      </Menu>
    );
  };

  focusEncaminhamentos = () => {
    this.expandSection("actions");
    if (typeof document === "undefined") return;
    window.setTimeout(() => {
      const el = document.getElementById("ata-actions-section");
      if (el && typeof el.scrollIntoView === "function") {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }, 50);
  };

  onApproveAta = () => {
    const { t, alert } = this.props;
    const { ata } = this.state;
    if (!ata || !canApproveAtaDraft(ata)) return;
    const updated = approveAtaDraft(ata.id);
    if (!updated) {
      if (alert) alert.error(t("smartMinutes.approveError"));
      return;
    }
    this.setState({ ata: updated });
    if (alert) alert.success(t("smartMinutes.approveSuccess"));
  };

  focusAudioSection = () => {
    this.expandSection("audio");
    if (typeof document === "undefined") return;
    window.setTimeout(() => {
      const el = document.getElementById("ata-audio-section");
      if (el && typeof el.scrollIntoView === "function") {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }, 50);
  };

  onDownloadTranscript = () => {
    const { t } = this.props;
    const { alert } = this.props;
    const { ata } = this.state;
    if (!ata) return;
    downloadTranscript(ata);
    alert.show(t("smartMinutes.download.transcriptDone"), {
      title: t("smartMinutes.title")
    });
  };

  onDownloadAudio = async () => {
    const { t } = this.props;
    const { alert } = this.props;
    const { ata } = this.state;
    if (!ata || !ata.audioFileName) {
      alert.show(t("smartMinutes.download.noAudio"), {
        title: t("common.actions.attention")
      });
      return;
    }
    const result = await downloadAudioPlaceholder(ata);
    alert.show(
      result && result.kind === "audio"
        ? t("smartMinutes.download.audioStarted")
        : t("smartMinutes.download.audioDemo"),
      { title: t("smartMinutes.title") }
    );
  };

  onAttributeSpeakers = async () => {
    const { t } = this.props;
    const { alert } = this.props;
    const { ata, attributing } = this.state;
    if (!ata || attributing) return;
    if (!ata.meetingId) {
      alert.show(t("smartMinutes.noMeetingId"), {
        title: t("common.actions.attention")
      });
      return;
    }
    this.setState({ attributing: true });
    try {
      const result = await SmartMinutesService.attributeSmartMinutesSpeakers({
        meetingId: ata.meetingId,
        draftId: ata.id
      });
      const knownNames = listPersonOptions(ata).map(o => o.name);
      const transcriptText = normalizeAttributedTranscript(
        (result && result.transcriptText) || ata.transcriptText,
        { knownNames }
      );
      const speakers = buildSpeakersFromAta({ ...ata, transcriptText });
      const voicesLinked =
        speakers.length > 0 &&
        speakers.every(s => s.personId && s.linkSource === "manual");
      const updated = updateAtaDraft(ata.id, {
        transcriptText,
        speakers,
        voicesLinked,
        participantsDetected:
          (result && result.participantsDetected) || ata.participantsDetected
      });
      this.setState({
        ata: updated,
        transcriptFlash: true,
        attributing: false
      });
      if (this.transcriptFlashTimer) clearTimeout(this.transcriptFlashTimer);
      this.transcriptFlashTimer = setTimeout(() => {
        this.setState({ transcriptFlash: false });
        this.transcriptFlashTimer = null;
      }, 900);
      if (typeof window !== "undefined") {
        window.dispatchEvent(
          new CustomEvent("ata-drafts-updated", { detail: { id: ata.id } })
        );
      }
      const ok =
        result &&
        (result.attributed || transcriptHasSpeakerTurns(transcriptText));
      alert.show(ok ? t("smartMinutes.splitOk") : t("smartMinutes.splitWeak"), {
        title: t("smartMinutes.title"),
        type: ok ? "success" : "info"
      });
    } catch (e) {
      this.setState({ attributing: false });
      const apiMsg =
        e &&
        e.response &&
        e.response.data &&
        e.response.data.error &&
        e.response.data.error.message;
      alert.show(
        apiMsg || (e && e.message) || t("smartMinutes.reidentifyError"),
        { title: t("common.labels.error") }
      );
    }
  };

  /**
   * Recarrega a ata do servidor (transcrição após job / STT).
   * Preferível ao "identificar falantes" quando o pipeline já atribuiu no process.
   */
  onReloadTranscript = async () => {
    const { t, alert } = this.props;
    const { ata, reloadingTranscript } = this.state;
    if (!ata || reloadingTranscript) return;
    this.setState({ reloadingTranscript: true });
    try {
      let next = ata;
      if (!isClassDiaryDemo()) {
        const remote = await fetchAtaDraftFromServer(ata.id);
        if (remote) next = remote;
      } else {
        next = getAtaDraft(ata.id) || ata;
      }
      const ensured = ensureAtaSpeakers(next);
      next = updateAtaDraft(ensured.id || ata.id, {
        speakers: ensured.speakers,
        voicesLinked: ensured.voicesLinked,
        transcriptText: ensured.transcriptText
      });
      const hasTurns = transcriptHasSpeakerTurns(next.transcriptText);
      const stillProcessing =
        !next.transcriptText ||
        String(next.transcriptText).includes(
          t("smartMinutes.new.processingNote").slice(0, 20)
        ) ||
        /Processando áudio|Processing audio/i.test(next.transcriptText);
      this.setState({
        ata: next,
        reloadingTranscript: false,
        transcriptFlash: true,
        transcriptPage: 0
      });
      if (this.transcriptFlashTimer) clearTimeout(this.transcriptFlashTimer);
      this.transcriptFlashTimer = setTimeout(() => {
        this.setState({ transcriptFlash: false });
        this.transcriptFlashTimer = null;
      }, 900);
      if (typeof window !== "undefined") {
        window.dispatchEvent(
          new CustomEvent("ata-drafts-updated", { detail: { id: next.id } })
        );
      }
      if (stillProcessing) {
        alert.show(t("smartMinutes.transcriptStillProcessing"), {
          title: t("smartMinutes.title"),
          type: "info"
        });
      } else if (hasTurns) {
        alert.show(t("smartMinutes.transcriptReloaded"), {
          title: t("smartMinutes.title"),
          type: "success"
        });
      } else {
        alert.show(t("smartMinutes.transcriptReloadedRaw"), {
          title: t("smartMinutes.title"),
          type: "info"
        });
      }
    } catch (e) {
      this.setState({ reloadingTranscript: false });
      const apiMsg =
        e &&
        e.response &&
        e.response.data &&
        e.response.data.error &&
        e.response.data.error.message;
      alert.show(
        apiMsg || (e && e.message) || t("smartMinutes.transcriptReloadError"),
        { title: t("common.labels.error") }
      );
    }
  };

  resolvePersonIdForSpeaker = speaker => {
    const { ata } = this.state;
    if (!ata || !speaker) return null;
    if (speaker.personId) return speaker.personId;
    if (speaker.suggestedPersonId) return speaker.suggestedPersonId;
    const options = listPersonOptions(ata);
    const candidates = [
      speaker.suggestedPersonName,
      speaker.personName,
      speaker.detectedName,
      speaker.label
    ]
      .map(n =>
        String(n || "")
          .trim()
          .toLowerCase()
      )
      .filter(Boolean);
    for (let i = 0; i < candidates.length; i += 1) {
      const key = candidates[i];
      const hit = options.find(
        o =>
          String(o.name || "")
            .trim()
            .toLowerCase() === key
      );
      if (hit) return hit.id;
    }
    return null;
  };

  /**
   * ✓ na fala do participante: confirma na transcrição + reforça no vector.
   */
  onKeepVoiceSample = (speaker, sample) => {
    const { t } = this.props;
    const { ata } = this.state;
    const { alert } = this.props;
    if (!ata || !speaker || !sample) return;
    const sampleId = sample.id || sample.turnId;
    const turnId = sample.turnId || sample.id;
    const turn = this.getTimedTurns().find(item => item.id === turnId);
    if (!turn) {
      alert.show(t("smartMinutes.speechNotFound"), {
        title: t("common.actions.attention")
      });
      return;
    }

    const personId = this.resolvePersonIdForSpeaker(speaker);
    if (!personId) {
      alert.show(t("smartMinutes.chooseSuggestedBeforeConfirm"), {
        title: t("common.actions.attention")
      });
      return;
    }

    const excludedSampleIds = (speaker.excludedSampleIds || []).filter(
      id => id !== sampleId
    );
    const speakers = (ata.speakers || []).map(s =>
      s.id === speaker.id ? { ...s, excludedSampleIds } : s
    );
    updateAtaDraft(ata.id, { speakers });
    const fresh = getAtaDraft(ata.id) || { ...ata, speakers };
    // Confirma fala (turnLinks + confirmSpeakerVoice / profile)
    this.setState({ ata: fresh }, () => {
      this.onLinkTurnSpeaker(turn, personId);
    });
  };

  /**
   * Exclui só como amostra do participante; a fala fica na transcrição
   * como não confirmada (desvincula se estava confirmada).
   */
  onExcludeVoiceSample = (speaker, sample) => {
    const { ata } = this.state;
    if (!ata || !speaker || !sample) return;
    const sampleId = sample.id || sample.turnId;
    const turnId = sample.turnId || sample.id;
    const excludedSampleIds = [
      ...new Set([...(speaker.excludedSampleIds || []), sampleId])
    ];
    const speakers = (ata.speakers || []).map(s =>
      s.id === speaker.id ? { ...s, excludedSampleIds } : s
    );
    let updated = updateAtaDraft(ata.id, { speakers }) || ata;

    const turn = this.getTimedTurns().find(item => item.id === turnId);
    if (turn) {
      const link = getTurnLink(updated, turn.id);
      if (link && link.linkSource === "manual" && link.personId) {
        const patch = applyTurnPersonToAta(updated, turn, null);
        if (patch) {
          updated = updateAtaDraft(updated.id, patch) || updated;
        }
      }
    }

    this.setState({ ata: updated });
    if (ata.meetingId) {
      SmartMinutesService.excludeVoiceSample({
        meetingId: ata.meetingId,
        speakerClusterId: speaker.id,
        sampleId,
        turnId: sample.turnId || turnId
      }).catch(() => {});
    }
  };

  pinNavigationTurn = (turnId, targetSec) => {
    this.navPinTurnId = turnId || null;
    this.navPinTargetSec = Number.isFinite(targetSec) ? Number(targetSec) : null;
    // Curto: só cobre o gap do seek. Sem renovação infinita (travava avanço/sync).
    this.navPinUntil = turnId ? Date.now() + 3500 : 0;
  };

  clearNavigationPin = () => {
    this.navPinTurnId = null;
    this.navPinTargetSec = null;
    this.navPinUntil = 0;
  };

  goToTurnIndex = (index, opts = {}) => {
    const turns = this.getTimedTurns();
    if (!turns.length) return;
    const i = Math.max(0, Math.min(turns.length - 1, index));
    const turn = turns[i];
    if (!turn) return;
    const startSec = Number.isFinite(turn.startSec) ? turn.startSec : 0;
    const shouldPlay = !!opts.play;
    // playFragment: mesma regra do ▶ do card (para no fim; permite replay)
    const playFragment = opts.playFragment === true || opts.fragment === true;
    this.segmentPauseForTurnId = null;
    this.pinNavigationTurn(turn.id, startSec);

    if (shouldPlay && playFragment) {
      // Modo fala via player principal: para no fim da fala (não continuidade).
      // Não usa confirmClipLockTurnId — esse lock é só p/ o ▶ do card (clipe à parte).
      this.fragmentOnlyPlayback = true;
      this.confirmClipLockTurnId = null;
    } else if (!playFragment) {
      // Navegação manual (< >) ou play contínuo do player principal
      this.confirmClipLockTurnId = null;
      if (shouldPlay) {
        this.fragmentOnlyPlayback = false;
      }
    }

    // Lista da transcrição começa nesta fala; sem scroll automático
    this.setState(
      {
        transcriptListStart: i,
        transcriptPage: Math.floor(i / TRANSCRIPT_PAGE_SIZE),
        activeTurnId: turn.id,
        followAudio: false,
        audioPlaying: shouldPlay,
        audioCurrentSec: startSec,
        ...(shouldPlay && playFragment ? { continuousPlayback: false } : {})
      },
      () => {
        this.seekTranscriptTime(startSec, {
          play: shouldPlay,
          turnId: turn.id,
          fragment: shouldPlay && playFragment
        });
      }
    );
  };

  isTurnPending = (ata, turn) => {
    if (!ata || !turn) return false;
    const ids = expandTurnIds(turn);
    if (!ids.length) {
      const link = getTurnLink(ata, turn.id);
      return !(link && link.linkSource === "manual" && link.personId);
    }
    return ids.some(id => {
      const link = getTurnLink(ata, id);
      return !(link && link.linkSource === "manual" && link.personId);
    });
  };

  /**
   * "Onde parei": próxima fala pendente e toca só o fragmento
   * (para no fim; replay no ▶ do card se necessário).
   */
  goToFirstUnconfirmedTurn = () => {
    const { t } = this.props;
    const { ata, activeTurnId, audioCurrentSec } = this.state;
    const turns = this.getTimedTurns();
    if (!ata || !turns.length) {
      return;
    }
    // "Onde parei" = próxima pendente depois da fala atual (não a primeira da lista)
    const active =
      (activeTurnId && turns.find(turn => turn.id === activeTurnId)) ||
      findActiveTurn(turns, audioCurrentSec);
    const moved = this.goToNextPendingTurn(active && active.id, {
      playFragment: true,
      ata
    });
    if (!moved) {
      const { alert } = this.props;
      alert.show(t("smartMinutes.allConfirmed"), {
        title: t("smartMinutes.title"),
        type: "info"
      });
    }
  };

  /** Próxima fala ainda sem confirmação (após a atual; depois volta ao início). */
  goToNextPendingTurn = (afterTurnId, opts = {}) => {
    const { ata: stateAta } = this.state;
    const ata = opts.ata || stateAta;
    const turns = this.getTimedTurns();
    if (!ata || !turns.length) return false;
    const startIdx = afterTurnId
      ? turns.findIndex(turn => turn.id === afterTurnId)
      : -1;
    const order = [];
    // Depois da atual…
    for (let i = startIdx + 1; i < turns.length; i += 1) order.push(i);
    // …depois do início até antes da atual (não inclui a atual — evita “ficar parado”)
    if (startIdx < 0) {
      for (let i = 0; i < turns.length; i += 1) order.push(i);
    } else {
      for (let i = 0; i < startIdx; i += 1) order.push(i);
    }
    const nextIdx = order.find(i => this.isTurnPending(ata, turns[i]));
    if (nextIdx == null || nextIdx === undefined) return false;
    const playFragment = opts.playFragment === true;
    this.goToTurnIndex(nextIdx, {
      play: playFragment || opts.play === true,
      playFragment,
      fragment: playFragment || opts.fragment === true
    });
    return true;
  };

  openAddParticipantDialog = turn => {
    const { ata } = this.state;
    if (!ata || !turn) return;
    const speaker = findSpeakerForTurn(ata.speakers, turn.name);
    const suggested = suggestGuestFromDetectedName(
      (speaker && speaker.detectedName) || turn.name,
      (speaker && speaker.detectedRole) || null
    );
    this.setState(
      {
        addParticipantOpen: true,
        addParticipantTurn: turn,
        addParticipantPoolKey: "",
        addParticipantName: suggested.name,
        addParticipantRole:
          suggested.role || i18n.t("smartMinutes.role.coordination"),
        addParticipantLoading: true
      },
      () => {
        this.ensureParticipantPools().finally(() => {
          this.setState({ addParticipantLoading: false });
        });
      }
    );
  };

  closeAddParticipantDialog = () => {
    this.setState({
      addParticipantOpen: false,
      addParticipantTurn: null,
      addParticipantPoolKey: "",
      addParticipantName: "",
      addParticipantRole: i18n.t("smartMinutes.role.coordination"),
      addParticipantLoading: false
    });
  };

  /**
   * Atas antigas podem não ter pool; busca funcionários/responsáveis da turma.
   */
  ensureParticipantPools = async () => {
    const { ata } = this.state;
    if (!ata) return;
    let staffPool = Array.isArray(ata.staffPool) ? [...ata.staffPool] : [];
    const guardiansPoolByRa = {
      ...(ata.guardiansPoolByRa || {})
    };
    let changed = false;

    if (!staffPool.length && ata.classId) {
      try {
        const teachers = await TeacherService.getTeachers(
          "",
          ata.classId,
          "PROFESSOR,COORDENADOR"
        );
        staffPool = (teachers || [])
          .slice(0, 30)
          .map((t, idx) => mapTeacherToStaff(t, idx))
          .filter(p => p.name && !/^Funcionário(\s+\d+)?$/i.test(p.name));
      } catch (e) {
        staffPool = [];
      }
      if (!staffPool.length && isClassDiaryDemo()) {
        staffPool = buildDemoStaffForClass(ata.classId);
      }
      if (staffPool.length) changed = true;
    }

    const students = ata.students || [];
    await Promise.all(
      students.map(async s => {
        if (!s || !s.ra) return;
        if ((guardiansPoolByRa[s.ra] || []).length) return;
        try {
          const profile = await StudentService.getStudentById(s.ra || s.id);
          const contacts =
            profile.contacts ||
            (Array.isArray(profile.responsaveis)
              ? { resp: profile.responsaveis, respTransport: [] }
              : null);
          const enriched = enrichStudentWithGuardians(
            { ...s, contacts },
            { allowDemoFallback: isClassDiaryDemo() }
          );
          guardiansPoolByRa[s.ra] = (enriched.guardians || []).map(g => ({
            id: g.id,
            name: g.name,
            role: g.role,
            responsibility: g.responsibility || null,
            relationship: g.relationship || null
          }));
          if ((guardiansPoolByRa[s.ra] || []).length) changed = true;
        } catch (e) {
          if (isClassDiaryDemo()) {
            const enriched = enrichStudentWithGuardians(s, {
              allowDemoFallback: true
            });
            guardiansPoolByRa[s.ra] = (enriched.guardians || []).map(g => ({
              id: g.id,
              name: g.name,
              role: g.role,
              responsibility: g.responsibility || null,
              relationship: g.relationship || null
            }));
            if ((guardiansPoolByRa[s.ra] || []).length) changed = true;
          }
        }
      })
    );

    if (!changed) return;
    const updated = updateAtaDraft(ata.id, { staffPool, guardiansPoolByRa });
    if (updated) this.setState({ ata: updated });
  };

  onConfirmAddParticipant = () => {
    const {
      ata,
      addParticipantTurn,
      addParticipantPoolKey,
      addParticipantName,
      addParticipantRole
    } = this.state;
    if (!ata || !addParticipantTurn) return;

    const addable = listAddableParticipants(ata);
    let personSpec = null;
    if (addParticipantPoolKey) {
      const fromPool = addable.find(
        p => `${p.kind}:${p.id}` === addParticipantPoolKey
      );
      if (fromPool) {
        personSpec = { ...fromPool };
      }
    }
    if (!personSpec) {
      const name = String(addParticipantName || "").trim();
      if (!name) return;
      personSpec = {
        kind: "staff",
        name,
        role: addParticipantRole || i18n.t("smartMinutes.participant")
      };
    }

    const added = addPersonToAta(ata, personSpec);
    if (!added || !added.personId) return;
    const withPerson =
      updateAtaDraft(ata.id, {
        staff: added.staff,
        students: added.students
      }) || ata;

    this.setState(
      {
        ata: withPerson,
        addParticipantOpen: false,
        addParticipantTurn: null,
        addParticipantPoolKey: "",
        addParticipantName: "",
        addParticipantRole: i18n.t("smartMinutes.role.coordination")
      },
      () => {
        this.onLinkTurnSpeaker(addParticipantTurn, added.personId);
      }
    );
  };

  /**
   * Confirma pessoa em UMA fala (e pedaços mergeados dela).
   * Em seguida consulta perfil de voz para sugerir nas demais falas ainda abertas.
   */
  onLinkTurnSpeaker = (turn, personId, opts = {}) => {
    const { ata } = this.state;
    if (!ata || !turn) return;
    const advance = opts.advance !== false;
    const personOptions = listPersonOptions(ata);
    const person = personId
      ? personOptions.find(o => o.id === personId) || null
      : null;

    let updated;
    let confirmedTurns = [turn];

    if (personId) {
      // Confirma o bloco consecutivo + atualiza sugestão nas demais
      // falas pendentes com o mesmo rótulo STT.
      const result = applyPersonSelectionToPendingTurns(
        ata,
        turn,
        personId,
        this.getTimedTurns()
      );
      if (!result || !result.patch) return;
      updated = updateAtaDraft(ata.id, result.patch);
      confirmedTurns = result.confirmedTurns || [turn];
    } else {
      const patch = applyTurnPersonToAta(ata, turn, personId);
      if (!patch) return;
      updated = updateAtaDraft(ata.id, patch);
    }

    if (updated && updated.voicesLinked && !canShowEncaminhamentos(updated)) {
      updated = releasePendingActions(updated.id) || updated;
    }

    // Confirmar fala: responsável do encaminhamento + timbre/tom da voz
    if (personId && person && updated) {
      const assigneePatch = applyAssigneeFromConfirmedTurn(
        updated,
        turn,
        person
      );
      if (assigneePatch) {
        updated = updateAtaDraft(updated.id, assigneePatch) || updated;
      }
      const voicePatch = applyVoiceTraitsFromConfirm(updated, turn, person);
      if (voicePatch) {
        updated = updateAtaDraft(updated.id, voicePatch) || updated;
      }
    }

    const navFromId =
      (confirmedTurns.length &&
        confirmedTurns[confirmedTurns.length - 1].id) ||
      turn.id;

    this.setState(
      {
        ata: updated,
        speakerMenuAnchor: null,
        speakerMenuTurnId: null
      },
      () => {
        // Após confirmar: vai à próxima pendente e já toca (fluxo de validação)
        if (advance && personId && updated) {
          this.goToNextPendingTurn(navFromId, {
            playFragment: true,
            ata: updated
          });
        }
        if (typeof window !== "undefined") {
          window.dispatchEvent(
            new CustomEvent("ata-drafts-updated", { detail: { id: ata.id } })
          );
        }
      }
    );

    logVoiceLinkEvent({
      ataId: ata.id,
      meetingId: ata.meetingId,
      speaker: { id: turn.id, detectedName: turn.name },
      person,
      personId,
      action: personId ? "link_turn" : "unlink_turn"
    });

    if (personId && person && updated && updated.meetingId) {
      this.confirmTurnVoiceAndSuggest(updated, turn, person);
    }
  };

  resolveVoiceCluster = (ata, turn) => {
    const sp = findSpeakerForTurn(
      (ata && ata.speakers) || [],
      turn && turn.name
    );
    return {
      speakerClusterId: (sp && sp.id) || (turn && turn.id),
      voiceKey:
        (turn && turn.name) || (sp && (sp.detectedName || sp.label)) || null
    };
  };

  confirmTurnVoiceAndSuggest = (ata, turn, person) => {
    const { speakerClusterId, voiceKey } = this.resolveVoiceCluster(ata, turn);
    SmartMinutesService.confirmSpeakerVoice({
      meetingId: ata.meetingId,
      speakerClusterId,
      voiceKey,
      personKey: person.id,
      displayName: person.name,
      consent: true
    })
      .then(confirmResult => {
        const turns = this.getTimedTurns();
        const links = { ...(ata.turnLinks || {}) };
        const prevLink = links[turn.id] || {};
        const apiScore =
          confirmResult && Number.isFinite(confirmResult.matchConfidence)
            ? confirmResult.matchConfidence
            : null;
        const prevSuggest = Number.isFinite(prevLink.voiceSuggestScore)
          ? prevLink.voiceSuggestScore
          : null;
        const scoreSource =
          (confirmResult && confirmResult.scoreSource) || "sample_embedding";
        // Não regredir o % da sugestão se a API devolver score baixo/ruído
        let matchConfidence = apiScore;
        if (Number.isFinite(apiScore) && Number.isFinite(prevSuggest)) {
          matchConfidence = Math.max(apiScore, prevSuggest);
        } else if (!Number.isFinite(apiScore) && Number.isFinite(prevSuggest)) {
          matchConfidence = prevSuggest;
        }
        // A fala que acabamos de confirmar já está no draft atualizado
        links[turn.id] = {
          ...prevLink,
          personId: person.id,
          personName: person.name,
          linkSource: "manual",
          matchConfidence,
          voiceSuggestSource: scoreSource
        };
        if (Number.isFinite(matchConfidence)) {
          const { ata: current } = this.state;
          if (current && current.id === ata.id) {
            const curLink = (current.turnLinks || {})[turn.id] || {};
            const next = updateAtaDraft(current.id, {
              turnLinks: {
                ...(current.turnLinks || {}),
                [turn.id]: {
                  ...curLink,
                  matchConfidence,
                  voiceSuggestSource: scoreSource,
                  voiceSuggestScore: Number.isFinite(prevSuggest)
                    ? prevSuggest
                    : curLink.voiceSuggestScore
                }
              }
            });
            if (next) this.setState({ ata: next });
          }
        }
        const clusters = turns
          .filter(t => !(links[t.id] && links[t.id].linkSource === "manual"))
          .map(t => {
            const sp = findSpeakerForTurn(ata.speakers, t.name);
            const link = links[t.id];
            const sameSttConfirmed = turns.find(
              x =>
                x.id !== t.id &&
                String(x.name || "").toLowerCase() ===
                  String(t.name || "").toLowerCase() &&
                links[x.id] &&
                links[x.id].linkSource === "manual"
            );
            const cluster = this.resolveVoiceCluster(ata, t);
            return {
              speakerClusterId: cluster.speakerClusterId,
              turnId: t.id,
              voiceKey: cluster.voiceKey,
              personKeyHint:
                (link && link.suggestedPersonId) ||
                (sameSttConfirmed && links[sameSttConfirmed.id].personId) ||
                (sp && sp.suggestedPersonId) ||
                null
            };
          });
        if (!clusters.length) return null;
        return SmartMinutesService.suggestSpeakersByVoice({
          meetingId: ata.meetingId,
          clusters,
          limit: 3
        });
      })
      .then(suggest => {
        if (!suggest || !suggest.results) return;
        const suggestions = [];
        suggest.results.forEach(row => {
          const ranked = (row.matches || [])
            .filter(m => m && Number(m.score) >= ALT_VOICE_SCORE)
            .slice()
            .sort((a, b) => Number(b.score) - Number(a.score));
          const best = ranked.find(m => Number(m.score) >= 0.75);
          if (!best) return;
          const turnId = row.turnId || row.speakerClusterId;
          if (!turnId) return;
          suggestions.push({
            turnId,
            personId: best.personKey,
            personName: best.displayName,
            score: best.score,
            scoreSource:
              best.scoreSource || row.scoreSource || "sample_embedding",
            alternates: ranked.slice(1).map(m => ({
              personId: m.personKey,
              personName: m.displayName,
              score: m.score
            }))
          });
        });
        if (!suggestions.length) return;
        const { ata: current } = this.state;
        if (!current) return;

        let next = current;
        // ≥80%: pré-indica no seletor (suggestion); usuário confirma ou altera
        const suggestPatch = applyTurnVoiceSuggestions(next, suggestions);
        if (suggestPatch) {
          next = updateAtaDraft(next.id, suggestPatch) || next;
        }

        if (next.speakers) {
          const speakers = syncSpeakerSamplesFromTurnLinks(
            attachMockVoiceSamples(
              next.speakers,
              next.transcriptText,
              next.diarizedSegments
            ),
            next.turnLinks,
            next.transcriptText
          );
          next = updateAtaDraft(next.id, { speakers }) || next;
        }

        this.setState({ ata: next });
        if (typeof window !== "undefined") {
          window.dispatchEvent(
            new CustomEvent("ata-drafts-updated", { detail: { id: next.id } })
          );
        }
      })
      .catch(() => {});
  };

  onConfirmTurnSuggestion = turn => {
    const { t } = this.props;
    const { ata } = this.state;
    if (!ata || !turn) return;
    const speaker = findSpeakerForTurn(ata.speakers, turn.name);
    const turnLink = getTurnLink(ata, turn.id);
    const shown = displaySpeakerForTurn(turn, speaker, turnLink, ata);
    const personId = shown.suggestedPersonId;
    if (!personId) {
      const { alert } = this.props;
      alert.show(t("smartMinutes.chooseBeforeConfirm"), {
        title: t("common.actions.attention")
      });
      return;
    }
    // Um botão: confirma a fala atual (+ merge) e as próximas iguais até mudar a voz
    const turns = this.getTimedTurns();
    const runInfo = getConfirmSpeakerRun(turns, ata, turn);
    const pending = listPendingTurnsInRun(ata, (runInfo && runInfo.run) || [turn]);
    if (pending.length > 1) {
      this.onConfirmSameSpeakerRun(turn, personId);
      return;
    }
    this.onLinkTurnSpeaker(turn, personId);
  };

  /**
   * Confirma o bloco à frente (mesmo STT até fronteira de voz / Ana).
   */
  onConfirmSameSpeakerRun = (turn, personId) => {
    const { t, alert } = this.props;
    const { ata } = this.state;
    if (!ata || !turn || !personId) {
      alert.show(t("smartMinutes.chooseBeforeConfirm"), {
        title: t("common.actions.attention")
      });
      return;
    }
    const turns = this.getTimedTurns();
    const runInfo = getConfirmSpeakerRun(turns, ata, turn);
    if (!runInfo) return;
    const pending = listPendingTurnsInRun(ata, runInfo.run);
    if (!pending.length) return;

    const personOptions = listPersonOptions(ata);
    const person = personOptions.find(o => o.id === personId) || null;
    const patch = applyTurnPersonToMany(ata, pending, personId);
    if (!patch) return;
    let updated = updateAtaDraft(ata.id, patch);

    if (updated && updated.voicesLinked && !canShowEncaminhamentos(updated)) {
      updated = releasePendingActions(updated.id) || updated;
    }

    if (person && updated) {
      const voicePatch = applyVoiceTraitsFromConfirm(
        updated,
        pending[0],
        person
      );
      if (voicePatch) {
        updated = updateAtaDraft(updated.id, voicePatch) || updated;
      }
    }

    const lastPending = pending[pending.length - 1];
    this.setState({ ata: updated }, () => {
      if (updated) {
        this.goToNextPendingTurn(lastPending.id, {
          playFragment: true,
          ata: updated
        });
      }
      if (typeof window !== "undefined") {
        window.dispatchEvent(
          new CustomEvent("ata-drafts-updated", { detail: { id: ata.id } })
        );
      }
    });

    if (person && updated && updated.meetingId) {
      this.confirmTurnVoiceAndSuggest(updated, pending[0], person);
    }
  };

  focusSpeakerInTranscript = speaker => {
    const turns = this.getTimedTurns();
    const match = turns.find(turn => findSpeakerForTurn([speaker], turn.name));
    if (!match) return;
    const idx = turns.findIndex(turn => turn.id === match.id);
    this.goToTurnIndex(idx);
  };

  closeDeleteDialog = () => {
    const { deletingAta } = this.state;
    if (deletingAta) return;
    this.setState({ confirmDelete: false, deleteConfirmText: "" });
  };

  renderAddParticipantDialog = () => {
    const { t } = this.props;
    const {
      ata,
      addParticipantOpen,
      addParticipantPoolKey,
      addParticipantName,
      addParticipantRole,
      addParticipantLoading
    } = this.state;
    if (!addParticipantOpen) return null;
    const addable = listAddableParticipants(ata);
    const canSubmit = !!(
      addParticipantPoolKey || String(addParticipantName || "").trim()
    );
    const roleOptions = guestRoleOptions();

    return (
      <Dialog
        open={addParticipantOpen}
        onClose={this.closeAddParticipantDialog}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>{t("smartMinutes.addParticipant")}</DialogTitle>
        <DialogContent>
          <Typography variant="body1" paragraph>
            {t("smartMinutes.addParticipantBody")}
          </Typography>
          {addParticipantLoading && (
            <Typography variant="body2" color="textSecondary" paragraph>
              {t("smartMinutes.searchingClassRoster")}
            </Typography>
          )}
          {addable.length > 0 && (
            <FormControl
              fullWidth
              variant="outlined"
              size="small"
              margin="normal"
            >
              <Select
                displayEmpty
                value={addParticipantPoolKey}
                onChange={e => {
                  const key = e.target.value;
                  const hit = addable.find(p => `${p.kind}:${p.id}` === key);
                  this.setState({
                    addParticipantPoolKey: key,
                    addParticipantName: hit ? hit.name : addParticipantName,
                    addParticipantRole: hit
                      ? hit.role || addParticipantRole
                      : addParticipantRole
                  });
                }}
              >
                <MenuItem value="">
                  <em>{t("smartMinutes.pickFromClass")}</em>
                </MenuItem>
                {addable.map(p => (
                  <MenuItem
                    key={`${p.kind}:${p.id}`}
                    value={`${p.kind}:${p.id}`}
                  >
                    {p.name}
                    {p.role ? ` (${formatParticipantRole(p.role)})` : ""}
                    {p.kind === "guardian"
                      ? t("smartMinutes.guardianSuffix")
                      : t("smartMinutes.staffSuffix")}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}
          <Typography
            variant="body2"
            color="textSecondary"
            style={{ marginTop: 8 }}
          >
            {t("smartMinutes.orTypeName")}
          </Typography>
          <TextField
            fullWidth
            margin="normal"
            variant="outlined"
            label={t("common.labels.name")}
            placeholder={t("smartMinutes.namePlaceholder")}
            value={addParticipantName}
            disabled={!!addParticipantPoolKey}
            onChange={e =>
              this.setState({
                addParticipantName: e.target.value,
                addParticipantPoolKey: ""
              })}
            InputLabelProps={{ shrink: true }}
          />
          <FormControl
            fullWidth
            variant="outlined"
            size="small"
            margin="normal"
            disabled={!!addParticipantPoolKey}
          >
            <Select
              value={addParticipantRole}
              onChange={e =>
                this.setState({ addParticipantRole: e.target.value })}
            >
              {roleOptions.map(opt => (
                <MenuItem key={opt} value={opt}>
                  {opt}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="secondary"
            onClick={this.closeAddParticipantDialog}
          >
            {t("common.actions.cancel")}
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={this.onConfirmAddParticipant}
            disabled={!canSubmit || addParticipantLoading}
          >
            {t("smartMinutes.addAndLink")}
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  onConfirmDelete = async () => {
    const { t } = this.props;
    const { history, alert } = this.props;
    const { ata, deleteConfirmText, deletingAta } = this.state;
    if (!ata || deletingAta) return;
    if (
      String(deleteConfirmText || "").trim() !==
      t("smartMinutes.delete.confirmWord")
    ) {
      alert.show(t("smartMinutes.delete.helperQuoted"), {
        title: t("smartMinutes.delete.needed")
      });
      return;
    }

    this.setState({ deletingAta: true });
    try {
      if (ata.meetingId) {
        try {
          await SmartMinutesService.purgeMeetingVoice({
            meetingId: ata.meetingId,
            reason: "meeting_deleted"
          });
        } catch (purgeErr) {
          // Purge de voz não deve impedir exclusão da ata.
          // eslint-disable-next-line no-console
          console.warn(
            "[ata] purge voice na exclusão falhou",
            purgeErr && purgeErr.message
          );
        }
      }
      await deleteAtaAudio(ata.id);
      await deleteAtaDraftRemote(ata.id, ata.meetingId);
      this.setState({
        confirmDelete: false,
        deleteConfirmText: "",
        deletingAta: false
      });
      history.push(this.listPath());
    } catch (e) {
      this.setState({ deletingAta: false });
      const apiMsg =
        e &&
        e.response &&
        e.response.data &&
        e.response.data.error &&
        e.response.data.error.message;
      alert.show(apiMsg || (e && e.message) || t("smartMinutes.delete.error"), {
        title: t("common.actions.error"),
        type: "error"
      });
    }
  };

  getTimedTurns = () => {
    const { ata, audioDurationSec } = this.state;
    const text = (ata && ata.transcriptText) || "";
    const knownNames = listPersonOptions(ata).map(o => o.name);
    const turns = parseTranscriptTurns(text, { knownNames });
    const diarized = attachDiarizedTimestamps(
      turns,
      ata && ata.diarizedSegments
    );
    let timed;
    if (diarized) {
      // Turnos sem match de diarize: completa com estimativa (não fica sem startSec)
      const estimated = attachEstimatedTimestamps(turns, audioDurationSec);
      timed = diarized.map((t, i) => {
        if (Number.isFinite(t.startSec) && Number.isFinite(t.endSec)) {
          return t;
        }
        const est = estimated[i];
        if (!est) return t;
        return {
          ...t,
          startSec: est.startSec,
          endSec: est.endSec,
          timeEstimated: true,
          diarized: false
        };
      });
    } else {
      timed = attachEstimatedTimestamps(turns, audioDurationSec);
    }
    // Une fragmentos curtos do mesmo falante; para se a voz sugerir outra pessoa
    return mergeConsecutiveSameSpeakerTurns(timed, ata);
  };

  /**
   * Fim do clipe da fala: endSec do turno, limitado pelo início da próxima
   * (evita “continuar” quando o timestamp está largo demais).
   */
  resolveTurnClipEndSec = turn => {
    if (!turn || !Number.isFinite(turn.startSec)) return null;
    const turns = this.getTimedTurns();
    const idx = turns.findIndex(
      t => t && (t.id === turn.id || (turn.id && (t.mergedTurnIds || []).includes(turn.id)))
    );
    const next = idx >= 0 ? turns[idx + 1] : null;
    let end = Number.isFinite(turn.endSec) ? Number(turn.endSec) : null;
    if (next && Number.isFinite(next.startSec)) {
      const nextStart = Number(next.startSec);
      if (!Number.isFinite(end) || end > nextStart + 0.05) {
        end = nextStart;
      }
    }
    if (!Number.isFinite(end) || end <= turn.startSec + 0.05) {
      end = Number(turn.startSec) + 8;
    }
    // Teto de segurança: clipe de confirmação não deve passar de 90s
    const maxEnd = Number(turn.startSec) + 90;
    if (end > maxEnd) end = maxEnd;
    return end;
  };

  isTurnConfirmed = turn => {
    const { ata } = this.state;
    if (!ata || !turn) return false;
    const ids = expandTurnIds(turn);
    if (!ids.length) return false;
    return ids.every(id => {
      const link = getTurnLink(ata, id);
      return !!(link && link.linkSource === "manual" && link.personId);
    });
  };

  getFilteredTurns = () => {
    const { transcriptQuery, transcriptFilter } = this.state;
    const turns = this.getTimedTurns();
    const q = String(transcriptQuery || "")
      .trim()
      .toLowerCase();

    return turns.filter(t => {
      if (transcriptFilter === TRANSCRIPT_FILTER_CONFIRMED) {
        if (!this.isTurnConfirmed(t)) return false;
      } else if (transcriptFilter === TRANSCRIPT_FILTER_PENDING) {
        if (this.isTurnConfirmed(t)) return false;
      }
      if (!q) return true;
      const hay = [t.name, t.role, t.text, formatTurnTime(t.startSec)]
        .filter(Boolean)
        .join(" ")
        .toLowerCase();
      return hay.includes(q);
    });
  };

  setTranscriptFilter = filter => {
    this.setState({
      transcriptFilter: filter,
      transcriptPage: 0,
      transcriptListStart: null,
      followAudio: false
    });
  };

  seekTranscriptTime = (startSec, opts = {}) => {
    if (!Number.isFinite(startSec)) return;
    if (typeof window === "undefined") return;
    const { ata } = this.state;
    const turns = this.getTimedTurns();
    const pinned = opts.turnId && turns.find(turn => turn.id === opts.turnId);
    const active = pinned || findActiveTurn(turns, startSec);
    const play = opts.play === true;
    const fragment = opts.fragment === true;
    // Seek manual / navegação: libera trava do modo fala a fala
    if (!opts.fromSegmentPause) {
      this.segmentPauseForTurnId = null;
    }
    if (active && active.id) {
      this.pinNavigationTurn(active.id, startSec);
    }
    // Clique na linha (edição): posiciona e pausa; play só se pedido
    this.setState({
      audioCurrentSec: startSec,
      activeTurnId: active ? active.id : null,
      followAudio: false,
      audioPlaying: play,
      ...(play && fragment ? { continuousPlayback: false } : {})
    });
    // Um único evento: o player faz seek e pausa/play conforme `play`
    window.dispatchEvent(
      new CustomEvent("ata-audio-seek", {
        detail: {
          ataId: ata && ata.id,
          time: startSec,
          play,
          fragment
        }
      })
    );
  };

  /**
   * Play ao lado de Confirmar: toca só o fragmento da fala atual.
   * Pausa no fim; ao tocar de novo, repete a mesma fala.
   * Áudio inteiro: usar o player principal da reunião.
   */
  replayTurnAudio = turn => {
    const { ata, audioPlaying, activeTurnId, audioCurrentSec } = this.state;
    if (typeof window === "undefined" || !ata || !turn) return;
    if (!Number.isFinite(turn.startSec)) return;

    const isThisTurn = activeTurnId === turn.id;
    const inTurn =
      isThisTurn &&
      Number.isFinite(audioCurrentSec) &&
      audioCurrentSec >= turn.startSec - 0.2 &&
      (!Number.isFinite(turn.endSec) || audioCurrentSec < turn.endSec - 0.08);

    if (audioPlaying && inTurn) {
      this.pauseMeetingAudio();
      return;
    }

    // Flag síncrona: o seek+play do player principal NÃO deve ligar continuidade
    this.fragmentOnlyPlayback = true;
    this.segmentPauseForTurnId = null;
    this.pinNavigationTurn(turn.id, turn.startSec);
    this.seekTranscriptTime(turn.startSec, {
      play: true,
      turnId: turn.id,
      fragment: true
    });
  };

  toggleTranscriptAudio = () => {
    const { ata, activeTurnId } = this.state;
    if (typeof window === "undefined" || !ata) return;
    const turns = this.getTimedTurns();
    const turn =
      (activeTurnId && turns.find(item => item.id === activeTurnId)) || null;
    // Mesmo comportamento: repetir a fala ativa (não pular para a próxima)
    if (turn) {
      this.replayTurnAudio(turn);
      return;
    }
    window.dispatchEvent(
      new CustomEvent("ata-audio-toggle", {
        detail: { ataId: ata.id }
      })
    );
  };

  pauseMeetingAudio = () => {
    const { ata } = this.state;
    if (typeof window === "undefined" || !ata) return;
    window.dispatchEvent(
      new CustomEvent("ata-audio-pause", {
        detail: { ataId: ata.id }
      })
    );
  };

  /**
   * Play iniciado pelo usuário no player principal da reunião:
   * toca o áudio inteiro (sem pausar entre falas).
   * Seek do play de fragmento não dispara este evento (ou vem com fragment=true).
   */
  onUserPlayAudio = event => {
    const { ata, continuousPlayback } = this.state;
    const detail = (event && event.detail) || {};
    if (!ata || (detail.ataId && detail.ataId !== ata.id)) return;
    if (detail.fragment === true) return;

    // Player principal: libera lock do card e entra em continuidade
    this.confirmClipLockTurnId = null;
    this.fragmentOnlyPlayback = false;
    this.segmentPauseForTurnId = null;
    if (!continuousPlayback) {
      this.setState({ continuousPlayback: true });
    }
  };

  onConfirmClipPlay = turn => {
    if (!turn) return;
    const end = this.resolveTurnClipEndSec(turn);
    this.confirmClipLockTurnId = turn.id;
    this.fragmentOnlyPlayback = true;
    this.segmentPauseForTurnId = null;
    this.pinNavigationTurn(turn.id, turn.startSec);
    // eslint-disable-next-line no-console
    console.info("[ata-clip] card PLAY lock turn", {
      turnId: turn.id,
      start: turn.startSec,
      end,
      name: turn.name
    });
    this.setState({
      activeTurnId: turn.id,
      audioCurrentSec: Number.isFinite(turn.startSec) ? turn.startSec : 0,
      continuousPlayback: false,
      audioPlaying: false,
      followAudio: false
    });
    this.pauseMeetingAudio();
  };

  onConfirmClipStop = turn => {
    if (!turn) return;
    // Mantém o mesmo card (permite retocar); não avança para a próxima fala
    this.confirmClipLockTurnId = turn.id;
    // eslint-disable-next-line no-console
    console.info("[ata-clip] card STOP keep turn", {
      turnId: turn.id,
      start: turn.startSec,
      name: turn.name
    });
    this.setState({
      activeTurnId: turn.id,
      audioCurrentSec: Number.isFinite(turn.startSec) ? turn.startSec : 0,
      audioPlaying: false,
      continuousPlayback: false,
      followAudio: false
    });
    // Player principal alinhado (pausado) no início desta fala — sem play
    if (Number.isFinite(turn.startSec)) {
      this.seekTranscriptTime(turn.startSec, {
        play: false,
        turnId: turn.id,
        fragment: true
      });
    }
  };

  onAudioTimeUpdate = (currentTime, meta = {}) => {
    const turns = this.getTimedTurns();
    const t = Number(currentTime) || 0;
    const playing = !!meta.playing;
    const {
      audioCurrentSec,
      audioPlaying,
      activeTurnId: prevTurnId,
      transcriptQuery,
      transcriptPage,
      followAudio,
      continuousPlayback
    } = this.state;

    // Clipe do card ativo: nunca avançar o card pelo player principal
    if (this.confirmClipLockTurnId) {
      if (playing) {
        this.pauseMeetingAudio();
      }
      if (prevTurnId !== this.confirmClipLockTurnId) {
        this.setState({
          activeTurnId: this.confirmClipLockTurnId,
          audioPlaying: false
        });
      } else if (audioPlaying) {
        this.setState({ audioPlaying: false });
      }
      return;
    }

    // Fragmento (confirmação) tem prioridade sobre o state — evita race com setState
    const fragmentOnly =
      this.fragmentOnlyPlayback || continuousPlayback === false;

    const pinActive =
      !!this.navPinTurnId &&
      (Date.now() < this.navPinUntil ||
        this.segmentPauseForTurnId === this.navPinTurnId);
    const pinnedTurn = pinActive && turns.find(x => x.id === this.navPinTurnId);
    let preferredActive = null;

    // Navegação / confirmar: segura a fala pinada até o seek pousar no alvo.
    // Usa proximidade do target (não “qualquer ponto do range”, que liberava cedo
    // demais). Sem renovação infinita — isso travava o < > e dessincronizava.
    if (pinnedTurn) {
      const target = Number.isFinite(this.navPinTargetSec)
        ? this.navPinTargetSec
        : pinnedTurn.startSec;
      const holdSec = Number.isFinite(target) ? target : audioCurrentSec;
      const landed = Number.isFinite(target) && Math.abs(t - target) <= 0.5;
      const firmlyInside =
        Number.isFinite(pinnedTurn.startSec) &&
        t >= pinnedTurn.startSec - 0.02 &&
        (!Number.isFinite(pinnedTurn.endSec) ||
          t < pinnedTurn.endSec - 0.05);

      // Pausado: não libera o pin (senão findActiveTurn no fim pula p/ próxima)
      if (!playing) {
        if (
          prevTurnId !== pinnedTurn.id ||
          audioPlaying ||
          Math.abs((Number(audioCurrentSec) || 0) - holdSec) > 0.2
        ) {
          this.setState({
            audioPlaying: false,
            activeTurnId: pinnedTurn.id,
            audioCurrentSec: holdSec
          });
        }
        return;
      }

      if (landed || firmlyInside) {
        this.clearNavigationPin();
        preferredActive = pinnedTurn;
      } else {
        // Ainda buscando o trecho: mantém a fala na UI, sem fingir que já toca
        if (
          prevTurnId !== pinnedTurn.id ||
          audioPlaying ||
          Math.abs((Number(audioCurrentSec) || 0) - holdSec) > 0.2
        ) {
          this.setState({
            audioPlaying: false,
            activeTurnId: pinnedTurn.id,
            audioCurrentSec: holdSec
          });
        }
        return;
      }
    } else if (this.navPinTurnId && Date.now() >= this.navPinUntil) {
      this.clearNavigationPin();
    }

    // Modo fragmento (confirmação): pausa no fim da fala e permanece nela
    // (replay ao tocar de novo). Player principal: continuousPlayback=true.
    if (playing && fragmentOnly && turns.length) {
      const current =
        preferredActive ||
        (prevTurnId && turns.find(x => x.id === prevTurnId)) ||
        findActiveTurn(turns, t);
      if (
        current &&
        Number.isFinite(current.endSec) &&
        t >= current.endSec - 0.08
      ) {
        // Evita reentrada enquanto já pausamos esta fala
        if (this.segmentPauseForTurnId === current.id) {
          return;
        }
        this.segmentPauseForTurnId = current.id;
        this.pauseMeetingAudio();
        this.pinNavigationTurn(current.id, current.endSec);
        // Fica no fim da fala atual (não antecipa a próxima)
        this.setState({
          audioPlaying: false,
          activeTurnId: current.id,
          audioCurrentSec: current.endSec,
          followAudio: false,
          continuousPlayback: false
        });
        return;
      }
    }

    // No modo contínuo (player principal), libera trava de fragmento.
    if (!fragmentOnly) {
      this.segmentPauseForTurnId = null;
    }

    const active = preferredActive || findActiveTurn(turns, t);
    const sec = Math.floor(t);
    const activeTurnId = active ? active.id : null;

    if (
      sec === audioCurrentSec &&
      playing === audioPlaying &&
      activeTurnId === prevTurnId
    ) {
      return;
    }

    const turnChanged = activeTurnId !== prevTurnId;
    const next = {
      audioCurrentSec: sec,
      audioPlaying: playing,
      activeTurnId
    };

    // Paginação acompanha o áudio/scrubber quando a fala muda
    if (active && turnChanged && !String(transcriptQuery || "").trim()) {
      const idx = turns.findIndex(x => x.id === active.id);
      if (idx >= 0) {
        const page = Math.floor(idx / TRANSCRIPT_PAGE_SIZE);
        if (page !== transcriptPage) next.transcriptPage = page;
      }
    }

    this.setState(next, () => {
      if (!followAudio || !playing || !turnChanged || !activeTurnId) return;
      this.ignoreFollowUntil = Date.now() + 400;
      const el = this.turnCardRefs[activeTurnId];
      if (el && typeof el.scrollIntoView === "function") {
        el.scrollIntoView({ behavior: "smooth", block: "nearest" });
      }
    });
  };

  renderConfidenceTag = (confidence, confidenceSource) => {
    const { t } = this.props;
    const label = formatVoiceConfidence(confidence);
    if (!label) return null;
    const tone = voiceConfidenceStyle(confidence);
    // Tons suaves para tag de canto (sem competir com o restante do card)
    let softBg = "rgba(183, 28, 28, 0.08)";
    if (confidence >= 0.8) softBg = "rgba(46, 125, 50, 0.08)";
    else if (confidence >= 0.6) softBg = "rgba(230, 81, 0, 0.08)";
    const bySamples = confidenceSource === "sample_embedding";
    const tip = bySamples
      ? t("smartMinutes.voiceMatchHint")
      : t("smartMinutes.suggestionConfidence");
    return (
      <Tooltip title={tip}>
        <ConfidenceTag
          $color={tone.color}
          $bg={softBg}
          $border={`${tone.color}22`}
          onClick={e => e.stopPropagation()}
          onMouseDown={e => e.stopPropagation()}
        >
          <GraphicEqIcon />
          {label}
        </ConfidenceTag>
      </Tooltip>
    );
  };

  renderTurnParticipantControls = (turn, opts = {}) => {
    const { t } = this.props;
    const { ata } = this.state;
    if (!ata || !turn) return null;
    const showPlay = !!opts.showPlay;
    const compact = !!opts.compact;
    const canPlayClip = !!(
      showPlay &&
      Number.isFinite(turn.startSec) &&
      (ata.hasLocalAudio ||
        ata.hasRemoteAudio ||
        (ata.meetingId && ata.audioFileName))
    );
    const personOptions = listPersonOptions(ata);
    const speaker = findSpeakerForTurn(ata.speakers, turn.name);
    const turnLink = getTurnLink(ata, turn.id);
    const shown = displaySpeakerForTurn(turn, speaker, turnLink, ata);

    const resolveOptionId = (personId, personName) => {
      if (personId && personOptions.some(o => o.id === personId)) {
        return personId;
      }
      const key = normalizeNameKey(personName);
      if (!key) return null;
      const hit = personOptions.find(o => normalizeNameKey(o.name) === key);
      return hit ? hit.id : null;
    };

    // Seletor acompanha a mesma sugestão exibida no topo
    const suggestedSelectId = resolveOptionId(
      shown.suggestedPersonId,
      shown.suggestedPersonName || shown.name
    );
    const preselect =
      !shown.validated &&
      !!suggestedSelectId &&
      (!Number.isFinite(shown.confidence) ||
        shown.confidence >= PRESELECT_VOICE_SCORE);

    let selectValue = "";
    if (shown.validated) {
      selectValue =
        resolveOptionId(shown.personId, shown.name) || shown.personId || "";
    } else if (preselect) {
      selectValue = suggestedSelectId;
    }

    const personMetaLine = opt => {
      if (!opt) return "";
      const parts = [];
      if (opt.role) parts.push(formatParticipantRole(opt.role));
      const resp = formatResponsibilityLabel(opt.responsibility);
      if (resp) parts.push(resp);
      return parts.join(" · ");
    };

    const renderPersonOption = opt => {
      const meta = personMetaLine(opt);
      return (
        <PersonOptionLabel>
          <PersonOptionName>{opt.name}</PersonOptionName>
          {meta ? <PersonOptionMeta>{meta}</PersonOptionMeta> : null}
        </PersonOptionLabel>
      );
    };

    const allTurns = this.getTimedTurns();
    const runInfo = getConfirmSpeakerRun(allTurns, ata, turn);
    const pendingDisplay = runInfo
      ? listPendingDisplayTurnsInRun(ata, runInfo.run)
      : listPendingDisplayTurnsInRun(ata, [turn]);
    const batchCount = Math.max(pendingDisplay.length, 1);
    const confirmPersonId = selectValue || suggestedSelectId;

    const onConfirmClick = e => {
      e.stopPropagation();
      if (!confirmPersonId) return;
      if (batchCount > 1) {
        this.onConfirmSameSpeakerRun(turn, confirmPersonId);
      } else if (selectValue && selectValue !== suggestedSelectId) {
        this.onLinkTurnSpeaker(turn, selectValue);
      } else {
        this.onConfirmTurnSuggestion(turn);
      }
    };

    const confirmTitle =
      batchCount > 1
        ? t("smartMinutes.confirmSameSpeakerRunHint", {
            from: (runInfo && runInfo.startIndex + 1) || 1,
            to: (runInfo && runInfo.endIndex + 1) || 1,
            name: shown.name || (runInfo && runInfo.sttName) || ""
          })
        : t("smartMinutes.confirmSpeech");

    // Modo fala: clipe independente (não usa o player principal / continuidade)
    const clipEnd = this.resolveTurnClipEndSec(turn);
    const playBtn = canPlayClip ? (
      <span
        onClick={e => e.stopPropagation()}
        onKeyDown={e => e.stopPropagation()}
        onMouseDown={e => e.stopPropagation()}
        role="presentation"
        title={t("smartMinutes.listenFragmentOnly")}
      >
        <AtaAudioPlayer
          key={`clip-confirm-${turn.id}`}
          ataId={ata.id}
          meetingId={ata.meetingId}
          fileName={ata.audioFileName}
          variant="compact"
          sampleStartSec={turn.startSec}
          sampleEndSec={clipEnd}
          listenGlobalEvents={false}
          onClipPlay={() => this.onConfirmClipPlay(turn)}
          onClipStop={() => this.onConfirmClipStop(turn)}
        />
      </span>
    ) : null;

    if (compact) {
      return (
        <CompactConfirmRow
          onClick={e => e.stopPropagation()}
          onMouseDown={e => e.stopPropagation()}
        >
          {shown.validated ? (
            <DoneAllIcon
              titleAccess={t("smartMinutes.speechConfirmed")}
              style={{ color: appTheme.color.primary.dark, fontSize: 22 }}
            />
          ) : (
            <Button
              color="primary"
              variant="contained"
              disabled={!confirmPersonId}
              title={confirmTitle}
              onClick={onConfirmClick}
              style={{
                minWidth: 0,
                height: 30,
                padding: "0 10px",
                textTransform: "none"
              }}
            >
              {t("common.actions.confirm")}
            </Button>
          )}
          {playBtn}
        </CompactConfirmRow>
      );
    }

    return (
      <TurnControlsBar
        $compact={false}
        onClick={e => e.stopPropagation()}
        onMouseDown={e => e.stopPropagation()}
        onKeyDown={e => e.stopPropagation()}
      >
        <FormControl className="turn-select" size="small" variant="outlined">
          <Select
            displayEmpty
            value={selectValue}
            renderValue={value => {
              if (!value) {
                return (
                  <SelectHintItem>
                    {t("smartMinutes.selectParticipant")}
                  </SelectHintItem>
                );
              }
              const opt = personOptions.find(o => o.id === value);
              if (!opt) return value;
              return renderPersonOption(opt);
            }}
            MenuProps={{
              PaperProps: { style: { maxHeight: 360 } }
            }}
            onChange={e => {
              const next = e.target.value;
              if (next === ADD_PARTICIPANT_VALUE) {
                this.openAddParticipantDialog(turn);
                return;
              }
              this.onLinkTurnSpeaker(turn, next || null);
            }}
          >
            <MenuItem value="">
              <SelectHintItem>
                {t("smartMinutes.selectParticipant")}
              </SelectHintItem>
            </MenuItem>
            {personOptions.map(opt => (
              <MenuItem
                key={opt.id}
                value={opt.id}
                style={{ minHeight: 48, alignItems: "center" }}
              >
                {renderPersonOption(opt)}
              </MenuItem>
            ))}
            <MenuItem value={ADD_PARTICIPANT_VALUE}>
              <SelectAddItem>
                {t("smartMinutes.addParticipantEllipsis")}
              </SelectAddItem>
            </MenuItem>
          </Select>
        </FormControl>
        {!shown.validated && (
          <Button
            color="primary"
            variant="contained"
            disabled={!confirmPersonId}
            title={confirmTitle}
            onClick={onConfirmClick}
            style={{
              flex: "0 0 auto",
              minWidth: 0,
              height: 32,
              padding: "0 12px",
              textTransform: "none"
            }}
          >
            {t("common.actions.confirm")}
          </Button>
        )}
        {shown.validated && (
          <DoneAllIcon
            titleAccess={t("smartMinutes.speechConfirmed")}
            style={{
              flex: "0 0 auto",
              color: appTheme.color.primary.dark,
              fontSize: 22
            }}
          />
        )}
        {playBtn}
      </TurnControlsBar>
    );
  };

  renderLiveCaption = () => {
    const { t } = this.props;
    const { ata, audioCurrentSec, activeTurnId } = this.state;
    const turns = this.getTimedTurns();
    if (!turns.length) return null;

    const active =
      turns.find(turn => turn.id === activeTurnId) ||
      findActiveTurn(turns, audioCurrentSec);
    if (!active) return null;

    const activeIndex = Math.max(
      0,
      turns.findIndex(turn => turn.id === active.id)
    );
    const speaker = findSpeakerForTurn(
      (ata && ata.speakers) || [],
      active.name
    );
    const shown = displaySpeakerForTurn(
      active,
      speaker,
      getTurnLink(ata, active.id),
      ata
    );
    const timeLabel = formatTurnTime(
      Number.isFinite(audioCurrentSec) ? audioCurrentSec : active.startSec
    );
    // Texto estável da fala inteira (sem “correr” com o áudio — atrapalha a leitura)
    const captionText = cleanTurnBodyForDisplay(active.text);

    const metaLine = formatSpeakerMetaLine({
      role: shown.role,
      responsibility: shown.responsibility
    });

    return (
      <LiveCaption>
        <LiveCaptionHead>
          {timeLabel ? <TimeChip type="button">{timeLabel}</TimeChip> : null}
          <TurnIdentity>
            <SpeakerNameBtn
              type="button"
              title={t("smartMinutes.clickToChangeSpeaker")}
              onClick={e => this.openSpeakerMenu(e, active)}
            >
              <span className="speaker-name-row">
                <strong>
                  {shown.name}
                  {shown.validated ? " ✓" : ""}
                </strong>
                <ArrowDropDownIcon className="speaker-name-chevron" />
              </span>
              {metaLine ? (
                <SpeakerMetaLine>{metaLine}</SpeakerMetaLine>
              ) : null}
            </SpeakerNameBtn>
          </TurnIdentity>
          {this.renderConfidenceTag(shown.confidence, shown.confidenceSource)}
          <TurnNav>
            <IconButton
              size="small"
              color="primary"
              title={t("smartMinutes.prevSpeech")}
              disabled={activeIndex <= 0}
              onClick={() => this.goToTurnIndex(activeIndex - 1)}
            >
              <ChevronLeftIcon />
            </IconButton>
            <TurnNavIndex
              type="button"
              title={t("smartMinutes.navigateSpeeches")}
            >
              <span
                role="button"
                tabIndex={0}
                title={t("smartMinutes.goToSpeech")}
                onClick={() => this.goToTurnIndex(activeIndex)}
                onKeyDown={e => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    this.goToTurnIndex(activeIndex);
                  }
                }}
              >
                {activeIndex + 1}
              </span>
              <span aria-hidden>/</span>
              <span
                role="button"
                tabIndex={0}
                title={t("smartMinutes.goToLastSpeech")}
                onClick={() => this.goToTurnIndex(turns.length - 1)}
                onKeyDown={e => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    this.goToTurnIndex(turns.length - 1);
                  }
                }}
              >
                {turns.length}
              </span>
            </TurnNavIndex>
            <IconButton
              size="small"
              color="primary"
              title={t("smartMinutes.nextSpeech")}
              disabled={activeIndex >= turns.length - 1}
              onClick={() => this.goToTurnIndex(activeIndex + 1)}
            >
              <ChevronRightIcon />
            </IconButton>
            <Tooltip title={t("smartMinutes.whereILeft")}>
              <span>
                <IconButton
                  size="small"
                  color="primary"
                  aria-label={t("smartMinutes.whereILeftShort")}
                  onClick={this.goToFirstUnconfirmedTurn}
                >
                  <LastPageIcon />
                </IconButton>
              </span>
            </Tooltip>
          </TurnNav>
        </LiveCaptionHead>
        <LiveCaptionText>{captionText}</LiveCaptionText>
        {this.renderTurnParticipantControls(active, {
          showPlay: true,
          compact: true
        })}
      </LiveCaption>
    );
  };

  renderTranscript = () => {
    const { t } = this.props;
    const {
      ata,
      transcriptFlash,
      attributing,
      reloadingTranscript,
      transcriptQuery,
      transcriptFilter,
      transcriptPage,
      audioDurationSec,
      activeTurnId
    } = this.state;
    const text = (ata && ata.transcriptText) || "";
    const turns = this.getTimedTurns();
    const canPlayAudio = !!(
      ata &&
      (ata.hasLocalAudio ||
        ata.hasRemoteAudio ||
        (ata.meetingId && ata.audioFileName))
    );

    if (!turns.length) {
      const busy = attributing || reloadingTranscript;
      return (
        <>
          <Meta style={{ marginBottom: 10 }}>
            {t("smartMinutes.transcriptWaitingHint")}
          </Meta>
          <Box mb={2} display="flex" flexWrap="wrap" style={{ gap: 8 }}>
            <Button
              color="primary"
              variant="contained"
              disabled={busy}
              onClick={this.onReloadTranscript}
            >
              {reloadingTranscript
                ? t("smartMinutes.reloadingTranscript")
                : t("smartMinutes.reloadTranscript")}
            </Button>
          </Box>
          <TranscriptBox $flash={transcriptFlash}>{text}</TranscriptBox>
        </>
      );
    }

    const { transcriptListStart } = this.state;
    const timedTurns = turns;
    const confirmedCount = timedTurns.filter(turn => this.isTurnConfirmed(turn))
      .length;
    const pendingCount = Math.max(0, timedTurns.length - confirmedCount);
    const filtered = this.getFilteredTurns();
    const pageCount = Math.max(
      1,
      Math.ceil(filtered.length / TRANSCRIPT_PAGE_SIZE)
    );
    const page = Math.min(transcriptPage, pageCount - 1);
    const listStart =
      Number.isFinite(transcriptListStart) && transcriptListStart >= 0
        ? Math.min(transcriptListStart, Math.max(0, filtered.length - 1))
        : page * TRANSCRIPT_PAGE_SIZE;
    const slice = filtered.slice(listStart, listStart + TRANSCRIPT_PAGE_SIZE);
    const timeNote = Number.isFinite(audioDurationSec)
      ? t("smartMinutes.estimatedTimes")
      : t("smartMinutes.estimatedTimesNoMeta");

    return (
      <TranscriptTurns $flash={transcriptFlash}>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          flexWrap="wrap"
          style={{ gap: 10, marginBottom: 8 }}
        >
          <Meta>
            {t("smartMinutes.transcriptFilterSummary", {
              filtered: filtered.length,
              total: turns.length,
              timeNote
            })}
          </Meta>
          <TextField
            size="small"
            variant="outlined"
            placeholder={t("smartMinutes.searchTranscript")}
            value={transcriptQuery}
            onChange={e =>
              this.setState({
                transcriptQuery: e.target.value,
                transcriptPage: 0,
                transcriptListStart: null,
                followAudio: false
              })}
            style={{ minWidth: 220, flex: "1 1 220px", maxWidth: 360 }}
          />
        </Box>
        <Box
          display="flex"
          flexWrap="wrap"
          alignItems="center"
          style={{ gap: 6, marginBottom: 8 }}
        >
          <TranscriptFilterChip
            size="small"
            clickable
            $active={transcriptFilter === TRANSCRIPT_FILTER_ALL}
            label={t("smartMinutes.transcriptFilterAll", {
              count: timedTurns.length
            })}
            variant={
              transcriptFilter === TRANSCRIPT_FILTER_ALL
                ? "default"
                : "outlined"
            }
            color={
              transcriptFilter === TRANSCRIPT_FILTER_ALL ? "primary" : "default"
            }
            onClick={() => this.setTranscriptFilter(TRANSCRIPT_FILTER_ALL)}
          />
          <TranscriptFilterChip
            size="small"
            clickable
            $active={transcriptFilter === TRANSCRIPT_FILTER_PENDING}
            label={t("smartMinutes.transcriptFilterPending", {
              count: pendingCount
            })}
            onClick={() => this.setTranscriptFilter(TRANSCRIPT_FILTER_PENDING)}
            style={{
              background:
                transcriptFilter === TRANSCRIPT_FILTER_PENDING
                  ? "#e65100"
                  : "#fff3e0",
              color:
                transcriptFilter === TRANSCRIPT_FILTER_PENDING
                  ? "#fff"
                  : "#e65100"
            }}
          />
          <TranscriptFilterChip
            size="small"
            clickable
            $active={transcriptFilter === TRANSCRIPT_FILTER_CONFIRMED}
            label={t("smartMinutes.transcriptFilterConfirmed", {
              count: confirmedCount
            })}
            onClick={() =>
              this.setTranscriptFilter(TRANSCRIPT_FILTER_CONFIRMED)}
            style={{
              background:
                transcriptFilter === TRANSCRIPT_FILTER_CONFIRMED
                  ? appTheme.color.primary.dark
                  : appTheme.color.primary.light,
              color:
                transcriptFilter === TRANSCRIPT_FILTER_CONFIRMED
                  ? "#fff"
                  : appTheme.color.primary.dark
            }}
          />
        </Box>
        <Meta style={{ marginBottom: 4 }}>{t("smartMinutes.confirmHint")}</Meta>
        {!filtered.length && (
          <Meta style={{ marginBottom: 10 }}>
            {transcriptQuery.trim()
              ? t("smartMinutes.transcriptNoFilterMatchSearch")
              : t("smartMinutes.transcriptNoFilterMatch")}
          </Meta>
        )}
        {slice.map(turn => {
          const timeLabel = formatTurnTime(turn.startSec);
          const active = turn.id === activeTurnId;
          const speaker = findSpeakerForTurn(
            (ata && ata.speakers) || [],
            turn.name
          );
          const turnLink = getTurnLink(ata, turn.id);
          const shown = displaySpeakerForTurn(turn, speaker, turnLink, ata);
          const bodyText = cleanTurnBodyForDisplay(turn.text);
          return (
            <div
              key={turn.id}
              ref={el => {
                if (el) this.turnCardRefs[turn.id] = el;
                else delete this.turnCardRefs[turn.id];
              }}
            >
              <TurnCard
                $active={active}
                role="button"
                tabIndex={0}
                title={t("smartMinutes.goToClipPause")}
                onClick={() =>
                  this.seekTranscriptTime(turn.startSec, { play: false })}
                onKeyDown={e => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    this.seekTranscriptTime(turn.startSec, { play: false });
                  }
                }}
              >
                <Box display="flex" alignItems="flex-start" style={{ gap: 8 }}>
                  {timeLabel ? (
                    <TimeChip type="button" tabIndex={-1}>
                      {timeLabel}
                    </TimeChip>
                  ) : null}
                  <TurnIdentity>
                    <SpeakerNameBtn
                      type="button"
                      title={t("smartMinutes.clickToChangeSpeaker")}
                      onClick={e => this.openSpeakerMenu(e, turn)}
                      onMouseDown={e => e.stopPropagation()}
                    >
                      <span className="speaker-name-row">
                        <strong>
                          {shown.name}
                          {shown.validated ? " ✓" : ""}
                        </strong>
                        <ArrowDropDownIcon className="speaker-name-chevron" />
                      </span>
                      {(() => {
                        const metaLine = formatSpeakerMetaLine({
                          role: shown.role,
                          responsibility: shown.responsibility
                        });
                        if (!metaLine) return null;
                        return (
                          <SpeakerMetaLine>{metaLine}</SpeakerMetaLine>
                        );
                      })()}
                    </SpeakerNameBtn>
                  </TurnIdentity>
                  {canPlayAudio && Number.isFinite(turn.startSec) ? (
                    <span
                      onClick={e => e.stopPropagation()}
                      onKeyDown={e => e.stopPropagation()}
                      onMouseDown={e => e.stopPropagation()}
                      role="presentation"
                    >
                      <AtaAudioPlayer
                        ataId={ata.id}
                        meetingId={ata.meetingId}
                        fileName={ata.audioFileName}
                        variant="compact"
                        sampleStartSec={turn.startSec}
                        sampleEndSec={this.resolveTurnClipEndSec(turn)}
                        listenGlobalEvents={false}
                      />
                    </span>
                  ) : null}
                  {this.renderConfidenceTag(
                    shown.confidence,
                    shown.confidenceSource
                  )}
                </Box>
                <TurnSpeech>{bodyText}</TurnSpeech>
              </TurnCard>
            </div>
          );
        })}
        {pageCount > 1 && (
          <PagerRow>
            <Meta>
              {t("smartMinutes.pageOf", { page: page + 1, pageCount })}
            </Meta>
            <Box display="flex" style={{ gap: 8 }}>
              <Button
                color="primary"
                variant="outlined"
                disabled={page <= 0}
                onClick={() =>
                  this.setState({
                    transcriptPage: Math.max(0, page - 1),
                    transcriptListStart: null,
                    followAudio: false
                  })}
              >
                {t("common.actions.previous")}
              </Button>
              <Button
                color="primary"
                variant="outlined"
                disabled={page >= pageCount - 1}
                onClick={() =>
                  this.setState({
                    transcriptPage: Math.min(pageCount - 1, page + 1),
                    transcriptListStart: null,
                    followAudio: false
                  })}
              >
                {t("smartMinutes.nextPage")}
              </Button>
            </Box>
          </PagerRow>
        )}
      </TranscriptTurns>
    );
  };

  speakerSourceLabel = speaker => {
    const { t } = this.props;
    if (speaker.linkSource === "manual")
      return t("smartMinutes.validatedByYou");
    if (speaker.isNewParticipant) {
      return t("smartMinutes.newInConversation");
    }
    if (speaker.linkSource === "suggestion") {
      return t("smartMinutes.voiceSuggestion");
    }
    if (speaker.detectedFrom === "transcript") {
      return t("smartMinutes.identifiedInTranscript");
    }
    if (speaker.detectedFrom === "roster") {
      return t("smartMinutes.meetingGuest");
    }
    return "";
  };

  toggleSpeakerSamples = (speakerId, e) => {
    if (e) {
      e.stopPropagation();
      e.preventDefault();
    }
    if (!speakerId) return;
    this.setState(prev => ({
      expandedSpeakerSamples: {
        ...prev.expandedSpeakerSamples,
        [speakerId]: !prev.expandedSpeakerSamples[speakerId]
      }
    }));
  };

  onActionsChange = nextVisible => {
    const { ata, actionsFilter } = this.state;
    if (!ata) return;
    const nextActions = mergeFilteredActionEdits(
      ata.actions || [],
      nextVisible,
      actionsFilter
    );
    const updated = updateAtaDraft(ata.id, {
      actions: nextActions,
      actionsValidated: false
    });
    this.setState({ ata: updated });
    if (typeof window !== "undefined") {
      window.dispatchEvent(
        new CustomEvent("ata-drafts-updated", { detail: { id: ata.id } })
      );
    }
  };

  renderSpeakers = () => {
    const { t } = this.props;
    const { ata, expandedSpeakerSamples, reloadingTranscript } = this.state;
    const speakers = (ata && ata.speakers) || [];
    if (!speakers.length) return null;

    const summary = speakersSummary(
      speakers,
      ata.transcriptText,
      ata.turnLinks
    );
    const hasTurns = transcriptHasSpeakerTurns(ata.transcriptText);
    const speakersMinimized = this.isSectionMinimized("speakers");
    const speakersCompact = [
      t("smartMinutes.speakersCompact.participantCount", {
        count: speakers.length
      }),
      summary.newcomers
        ? t("smartMinutes.speakersChips.newcomers", {
            count: summary.newcomers
          })
        : null
    ]
      .filter(Boolean)
      .join(" · ");

    return (
      <Group>
        <TitleRow>
          <TitleCluster>
            <SectionIcon>
              <RecordVoiceOverIcon />
            </SectionIcon>
            <Heading level={2} gutterBottom={false}>
              {t("smartMinutes.speakersSection")}
            </Heading>
            {!speakersMinimized && summary.newcomers > 0 && (
              <Chip
                size="small"
                style={{ background: "#fff8e1", color: "#f57f17" }}
                label={t("smartMinutes.speakersChips.newcomers", {
                  count: summary.newcomers
                })}
              />
            )}
          </TitleCluster>
          {this.renderSectionCollapseBtn("speakers", {
            expand: t("smartMinutes.section.expandParticipants"),
            collapse: t("smartMinutes.section.collapseParticipants")
          })}
        </TitleRow>
        {speakersMinimized ? (
          <SectionCompactMeta>{speakersCompact}</SectionCompactMeta>
        ) : (
          <>
            <Meta style={{ marginTop: 8, marginBottom: 12 }}>
              {hasTurns
                ? t("smartMinutes.voiceConfirmHelp")
                : t("smartMinutes.noSpeechesYet")}
            </Meta>
            {!hasTurns && (
              <Box mb={2} display="flex" flexWrap="wrap" style={{ gap: 8 }}>
                <Button
                  color="primary"
                  variant="contained"
                  disabled={reloadingTranscript}
                  onClick={this.onReloadTranscript}
                >
                  {reloadingTranscript
                    ? t("smartMinutes.reloadingTranscript")
                    : t("smartMinutes.reloadTranscript")}
                </Button>
              </Box>
            )}

            {(() => {
              const timedTurns = this.getTimedTurns();
              const pendingBySpeaker = listPendingSamplesBySpeaker(
                speakers,
                timedTurns,
                ata.turnLinks
              );
              return speakers.map((speaker, speakerIndex) => {
                const pendingSamples = pendingBySpeaker[speaker.id] || [];
                const pendingTurns =
                  pendingSamples.length ||
                  countPendingTurnsForSpeaker(
                    speaker,
                    ata.turnLinks,
                    ata.transcriptText
                  );
                const needsValidation = pendingTurns > 0;
                const validated =
                  speaker.personId && speaker.linkSource === "manual";
                const clusterLabel =
                  speaker.label ||
                  speaker.participantLabel ||
                  t("smartMinutes.participantN", { n: speakerIndex + 1 });
                const suggestedName = speaker.suggestedPersonName || null;
                const displayName = validated
                  ? speaker.personName || clusterLabel
                  : clusterLabel;
                const sameSuggestedAsTitle =
                  suggestedName &&
                  String(displayName || "")
                    .trim()
                    .toLowerCase() ===
                    String(suggestedName)
                      .trim()
                      .toLowerCase();
                // Só mostra "Sugerido: Nome" se o título ainda for outro rótulo
                const showSuggestedLine =
                  !validated && suggestedName && !sameSuggestedAsTitle;
                const metaLine = formatSpeakerMetaLine({
                  role: speaker.personRole || speaker.detectedRole,
                  responsibility: getPersonResponsibility(
                    ata,
                    speaker.personId || speaker.suggestedPersonId,
                    {
                      name: speaker.personName || speaker.detectedName,
                      role: speaker.personRole || speaker.detectedRole
                    }
                  )
                });
                return (
                  <SpeakerCard
                    key={speaker.id}
                    $unlinked={needsValidation}
                    role="button"
                    tabIndex={0}
                    title={t("smartMinutes.viewSpeeches")}
                    onClick={() => this.focusSpeakerInTranscript(speaker)}
                    onKeyDown={e => {
                      if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        this.focusSpeakerInTranscript(speaker);
                      }
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    <SpeakerCardBody>
                      <SpeakerCardTop>
                        <SpeakerInfo>
                          <Typography
                            variant="subtitle2"
                            className="speaker-name"
                          >
                            <strong>
                              {displayName || t("smartMinutes.speakerFallback")}
                            </strong>
                          </Typography>
                          <SpeakerMetaLine className="speaker-meta">
                            {[metaLine, this.speakerSourceLabel(speaker)]
                              .filter(Boolean)
                              .join(" · ")}
                          </SpeakerMetaLine>
                          {showSuggestedLine && (
                            <SpeakerMetaLine>
                              {t("smartMinutes.suggestedPrefix")}
                              {" "}
                              {suggestedName}
                            </SpeakerMetaLine>
                          )}
                        </SpeakerInfo>
                        {pendingSamples.length > 0 && (
                          <SpeakerSamplesToggle
                            type="button"
                            title={t("smartMinutes.viewSpeeches")}
                            aria-expanded={!!expandedSpeakerSamples[speaker.id]}
                            onClick={e =>
                              this.toggleSpeakerSamples(speaker.id, e)}
                          >
                            {expandedSpeakerSamples[speaker.id]
                              ? t("smartMinutes.hidePendingSpeechesShort")
                              : t("smartMinutes.showPendingSpeechesShort", {
                                  count: pendingSamples.length
                                })}
                            {expandedSpeakerSamples[speaker.id] ? (
                              <ExpandLessIcon />
                            ) : (
                              <ExpandMoreIcon />
                            )}
                          </SpeakerSamplesToggle>
                        )}
                      </SpeakerCardTop>
                      {(() => {
                        if (
                          !pendingSamples.length ||
                          !expandedSpeakerSamples[speaker.id]
                        ) {
                          return null;
                        }
                        return (
                          <SampleList onClick={e => e.stopPropagation()}>
                            {pendingSamples.map(smp => {
                              const turn = timedTurns.find(
                                item =>
                                  item.id === smp.turnId || item.id === smp.id
                              );
                              const globalIdx = timedTurns.findIndex(
                                item => item.id === (turn && turn.id)
                              );
                              const timeLabel = formatTurnTime(smp.startSec);
                              const body = cleanTurnBodyForDisplay(
                                turn && turn.text
                              );
                              const legend = [timeLabel, body]
                                .filter(Boolean)
                                .join(" · ");
                              const falaLabel =
                                globalIdx >= 0 ? `# ${globalIdx + 1}` : "# ·";
                              return (
                                <SampleRow key={smp.id}>
                                  {ata.hasLocalAudio ||
                                  ata.hasRemoteAudio ||
                                  ata.meetingId ? (
                                    <AtaAudioPlayer
                                      ataId={ata.id}
                                      meetingId={ata.meetingId}
                                      variant="sample"
                                      label={falaLabel}
                                      sampleStartSec={smp.startSec}
                                      sampleEndSec={smp.endSec}
                                      listenGlobalEvents={false}
                                    />
                                  ) : (
                                    <SampleButtonFallback
                                      type="button"
                                      disabled
                                    >
                                      {falaLabel}
                                    </SampleButtonFallback>
                                  )}
                                  <IconButton
                                    size="small"
                                    color="primary"
                                    title={t(
                                      "smartMinutes.confirmSpeechInTranscript"
                                    )}
                                    onClick={e => {
                                      e.stopPropagation();
                                      this.onKeepVoiceSample(speaker, smp);
                                    }}
                                  >
                                    <CheckIcon fontSize="small" />
                                  </IconButton>
                                  <IconButton
                                    size="small"
                                    title={t(
                                      "smartMinutes.removeSpeechFromParticipant"
                                    )}
                                    onClick={e => {
                                      e.stopPropagation();
                                      this.onExcludeVoiceSample(speaker, smp);
                                    }}
                                  >
                                    <DeleteOutlineIcon fontSize="small" />
                                  </IconButton>
                                  {legend ? (
                                    <SampleLegend title={legend}>
                                      <span>{legend}</span>
                                    </SampleLegend>
                                  ) : (
                                    <span />
                                  )}
                                </SampleRow>
                              );
                            })}
                          </SampleList>
                        );
                      })()}
                    </SpeakerCardBody>
                  </SpeakerCard>
                );
              });
            })()}
          </>
        )}
      </Group>
    );
  };

  renderActionsPanel = () => {
    const { t } = this.props;
    const { ata, priorReviewsOpen, actionsFilter } = this.state;
    if (!ata) return null;
    const show = canShowEncaminhamentos(ata);
    const pendingCount = (ata.pendingActions || []).length;
    const actions = ata.actions || [];
    const reviews = ata.priorActionReviews || [];
    const actionsMinimized = this.isSectionMinimized("actions");
    const priorOpenById = new Map(
      (
        (ata.priorMeetingContext && ata.priorMeetingContext.openActions) ||
        []
      ).map(a => [String(a.id), a])
    );
    const priorSummaryById = new Map(
      (
        (ata.priorMeetingContext && ata.priorMeetingContext.priorAtasSummary) ||
        []
      ).map(a => [String(a.id), a])
    );

    const reviewItems = reviews.map(r => {
      const prior = priorOpenById.get(String(r.actionId || r.id));
      const originAta =
        (prior && prior.ataTitle) ||
        r.ataTitle ||
        (prior &&
          prior.ataId &&
          priorSummaryById.get(String(prior.ataId)) &&
          priorSummaryById.get(String(prior.ataId)).title) ||
        null;
      return {
        id: r.actionId || r.id,
        description: r.description || (prior && prior.description),
        assignee: r.assignee || (prior && prior.assignee),
        status: r.status,
        statusNote: r.note || r.statusNote,
        audience: r.audience,
        ataId: r.ataId || (prior && prior.ataId) || null,
        ataTitle: originAta,
        studentName: r.studentName || (prior && prior.studentName) || null
      };
    });

    const combinedForFilter = [...reviewItems, ...actions];
    const filterCounts = countActionsByFilter(combinedForFilter);
    const visibleReviews = filterActionsByStatus(reviewItems, actionsFilter);
    const visibleActions = filterActionsByStatus(actions, actionsFilter);
    const filterDefs = [
      { key: ACTIONS_FILTER.ALL, label: t("smartMinutes.filter.all") },
      { key: ACTIONS_FILTER.OPEN, label: t("smartMinutes.filter.open") },
      { key: ACTIONS_FILTER.DONE, label: t("smartMinutes.filter.done") },
      {
        key: ACTIONS_FILTER.CANCELLED,
        label: t("smartMinutes.filter.cancelled")
      }
    ];
    const hasAnyActions = combinedForFilter.length > 0;
    const filterEmpty =
      hasAnyActions && !visibleReviews.length && !visibleActions.length;

    let actionsCompact = t("smartMinutes.actionsCompact.awaiting");
    if (show) {
      actionsCompact = [
        t("smartMinutes.actionsCompact.count", { count: actions.length }),
        reviewItems.length
          ? t("smartMinutes.actionsCompact.fromPrior", {
              count: reviewItems.length
            })
          : null
      ]
        .filter(Boolean)
        .join(" · ");
    } else if (pendingCount > 0) {
      actionsCompact = t("smartMinutes.actionsCompact.suggestionsReady", {
        count: pendingCount
      });
    }

    const actionsHeader = (
      <TitleRow>
        <TitleCluster>
          <SectionIcon>
            <AssignmentTurnedInIcon />
          </SectionIcon>
          <Heading level={2} gutterBottom={false}>
            {t("smartMinutes.list.actions")}
          </Heading>
        </TitleCluster>
        {this.renderSectionCollapseBtn("actions", {
          expand: t("smartMinutes.section.expandActions"),
          collapse: t("smartMinutes.section.collapseActions")
        })}
      </TitleRow>
    );

    if (!show) {
      return (
        <Group id="ata-actions-section">
          {actionsHeader}
          {actionsMinimized ? (
            <SectionCompactMeta>{actionsCompact}</SectionCompactMeta>
          ) : (
            <Box mt={1.5}>
              <Meta>
                {pendingCount > 0
                  ? t("smartMinutes.action.aiSuggested")
                  : t("smartMinutes.action.aiPending")}
              </Meta>
            </Box>
          )}
        </Group>
      );
    }

    return (
      <Group id="ata-actions-section">
        {actionsHeader}
        {actionsMinimized ? (
          <SectionCompactMeta>{actionsCompact}</SectionCompactMeta>
        ) : (
          <Box mt={1.5}>
            {hasAnyActions && (
              <ActionsFilterRow
                role="tablist"
                aria-label={t("smartMinutes.action.filter")}
              >
                {filterDefs.map(f => (
                  <ActionsFilterChip
                    key={f.key}
                    type="button"
                    role="tab"
                    aria-selected={actionsFilter === f.key}
                    $active={actionsFilter === f.key}
                    onClick={() => this.setState({ actionsFilter: f.key })}
                  >
                    {f.label}
                    <span className="count">{filterCounts[f.key] || 0}</span>
                  </ActionsFilterChip>
                ))}
              </ActionsFilterRow>
            )}
            {filterEmpty && (
              <Meta style={{ marginBottom: 12 }}>
                {t("smartMinutes.action.noneInFilter")}
              </Meta>
            )}
            {visibleReviews.length > 0 && (
              <Box mb={2.5}>
                <SubSectionToggle
                  type="button"
                  aria-expanded={priorReviewsOpen}
                  aria-controls="ata-prior-actions"
                  onClick={() => {
                    this.setState(prev => ({
                      priorReviewsOpen: !prev.priorReviewsOpen
                    }));
                  }}
                >
                  {priorReviewsOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                  <SubSectionToggleLabel>
                    {t("smartMinutes.action.previousMeeting")}
                  </SubSectionToggleLabel>
                  <SubSectionCount>
                    {visibleReviews.length}
                    {visibleReviews.length !== reviewItems.length
                      ? t("smartMinutes.ofTotal", { count: reviewItems.length })
                      : ""}
                    {t("smartMinutes.action.returnStatus")}
                  </SubSectionCount>
                </SubSectionToggle>
                <Collapse in={priorReviewsOpen}>
                  <Box id="ata-prior-actions">
                    <AtaActionsGrouped
                      ata={ata}
                      actions={visibleReviews}
                      showStatus
                      showOrigin
                      muted
                    />
                  </Box>
                </Collapse>
              </Box>
            )}
            {visibleActions.length > 0 && reviewItems.length > 0 && (
              <ActionsSubhead>
                {t("smartMinutes.action.fromThisMeeting")}
              </ActionsSubhead>
            )}
            {(visibleActions.length > 0 ||
              actionsFilter === ACTIONS_FILTER.ALL ||
              actionsFilter === ACTIONS_FILTER.OPEN) &&
              !filterEmpty && (
                <AtaActionsGrouped
                  ata={ata}
                  actions={visibleActions}
                  editable
                  showStatus
                  onChange={this.onActionsChange}
                />
              )}
          </Box>
        )}
      </Group>
    );
  };

  render() {
    const { t } = this.props;
    const {
      ata,
      confirmDelete,
      deleteConfirmText,
      deletingAta,
      isMobileUi,
      heroCollapsed,
      heroMoreAnchor
    } = this.state;
    const deleteConfirmed =
      String(deleteConfirmText || "").trim() ===
      t("smartMinutes.delete.confirmWord");

    if (!ata) {
      return null;
    }

    const hasAudio = !!(
      ata.audioFileName ||
      ata.hasLocalAudio ||
      ata.hasRemoteAudio ||
      ata.meetingId
    );
    const hasTranscript = !!ata.transcriptText;
    const canPlayAudio = !!(
      ata.hasLocalAudio ||
      ata.hasRemoteAudio ||
      ata.meetingId
    );
    const hasSide = true;
    const actionsCount = (ata.actions || []).length;
    const summary = speakersSummary(
      ata.speakers,
      ata.transcriptText,
      ata.turnLinks
    );
    const turnsPct = summary.turnsTotal
      ? Math.round((summary.turnsLinked / summary.turnsTotal) * 100)
      : 0;
    const heroMinimized = isMobileUi && heroCollapsed;
    const statusLabel =
      getAtaStatusLabel(resolveAtaStatus(ata)) || resolveAtaStatus(ata);
    const heroCompactParts = [
      moment(ata.meetingAt || ata.createdAt).format("DD/MM/YYYY HH:mm"),
      summary.turnsTotal
        ? t("smartMinutes.list.turnsCompact", {
            linked: summary.turnsLinked,
            total: summary.turnsTotal,
            pct: turnsPct
          })
        : null,
      actionsCount > 0
        ? t("smartMinutes.list.encShort", { count: actionsCount })
        : null,
      statusLabel
    ].filter(Boolean);

    return (
      <Grid container spacing={2}>
        <BackButton to={this.listPath()} />

        <Grid item xs={12}>
          <DetailLayout $hasSide={hasSide} $hasAudio={hasAudio}>
            <HeaderCol>
              <HeroCard>
                <HeroTop>
                  <HeroBrandRow>
                    <HeroBrand>
                      <HeroIcon>
                        <MicIcon />
                      </HeroIcon>
                      <HeroTitleBlock>
                        <HeroEyebrow>{t("smartMinutes.title")}</HeroEyebrow>
                        <h1>{ata.title || t("smartMinutes.title")}</h1>
                      </HeroTitleBlock>
                    </HeroBrand>
                    <MobileCollapseBtn
                      type="button"
                      aria-expanded={!heroMinimized}
                      aria-label={
                        heroMinimized
                          ? t("smartMinutes.section.expandDetails")
                          : t("smartMinutes.section.collapseDetails")
                      }
                      onClick={this.toggleHeroCollapsed}
                    >
                      {heroMinimized ? <ExpandMoreIcon /> : <ExpandLessIcon />}
                    </MobileCollapseBtn>
                  </HeroBrandRow>
                  {!heroMinimized && (
                    <HeroControls>
                      <HeroActionRail>
                        {canApproveAtaDraft(ata) && (
                          <Tooltip title={t("smartMinutes.approveHint")}>
                            <span>
                              <GhostAction
                                type="button"
                                onClick={this.onApproveAta}
                              >
                                <DoneAllIcon />
                                {t("smartMinutes.approve")}
                              </GhostAction>
                            </span>
                          </Tooltip>
                        )}
                        {canPlayAudio && (
                          <span
                            onClick={this.focusAudioSection}
                            onKeyDown={e => {
                              if (e.key === "Enter" || e.key === " ") {
                                this.focusAudioSection();
                              }
                            }}
                            role="presentation"
                          >
                            <AtaAudioPlayer
                              ataId={ata.id}
                              meetingId={ata.meetingId}
                              fileName={ata.audioFileName}
                              variant="ghost"
                              label={t("smartMinutes.audio.listen")}
                            />
                          </span>
                        )}
                        {actionsCount > 0 && (
                          <Tooltip
                            title={t("smartMinutes.actionsTooltip", {
                              count: actionsCount
                            })}
                          >
                            <span>
                              <GhostAction
                                type="button"
                                onClick={this.focusEncaminhamentos}
                              >
                                <AssignmentTurnedInIcon />
                                <ActionCountBadge className="action-count">
                                  {actionsCount}
                                </ActionCountBadge>
                              </GhostAction>
                            </span>
                          </Tooltip>
                        )}
                        <>
                          <Tooltip title={t("smartMinutes.moreActions")}>
                            <IconButton
                              size="small"
                              aria-label={t("smartMinutes.moreActions")}
                              aria-haspopup="true"
                              aria-controls={
                                heroMoreAnchor
                                  ? "ata-hero-more-menu"
                                  : undefined
                              }
                              onClick={e =>
                                this.setState({
                                  heroMoreAnchor: e.currentTarget
                                })}
                            >
                              <MoreVertIcon />
                            </IconButton>
                          </Tooltip>
                          <Menu
                            id="ata-hero-more-menu"
                            anchorEl={heroMoreAnchor}
                            open={Boolean(heroMoreAnchor)}
                            onClose={() =>
                              this.setState({ heroMoreAnchor: null })}
                            getContentAnchorEl={null}
                            anchorOrigin={{
                              vertical: "bottom",
                              horizontal: "right"
                            }}
                            transformOrigin={{
                              vertical: "top",
                              horizontal: "right"
                            }}
                          >
                            {hasTranscript && (
                              <MenuItem
                                onClick={() => {
                                  this.setState({ heroMoreAnchor: null });
                                  this.onDownloadTranscript();
                                }}
                              >
                                <ListItemIcon style={{ minWidth: 36 }}>
                                  <DescriptionIcon fontSize="small" />
                                </ListItemIcon>
                                <ListItemText
                                  primary={t("smartMinutes.list.transcript")}
                                />
                              </MenuItem>
                            )}
                            {hasAudio && (
                              <MenuItem
                                onClick={() => {
                                  this.setState({ heroMoreAnchor: null });
                                  this.onDownloadAudio();
                                }}
                              >
                                <ListItemIcon style={{ minWidth: 36 }}>
                                  <HeadsetMicIcon fontSize="small" />
                                </ListItemIcon>
                                <ListItemText
                                  primary={t("smartMinutes.list.audio")}
                                />
                              </MenuItem>
                            )}
                            <MenuItem
                              onClick={() => {
                                this.setState({
                                  heroMoreAnchor: null,
                                  confirmDelete: true,
                                  deleteConfirmText: ""
                                });
                              }}
                            >
                              <ListItemIcon style={{ minWidth: 36 }}>
                                <DeleteIcon
                                  fontSize="small"
                                  style={{ color: "#c62828" }}
                                />
                              </ListItemIcon>
                              <ListItemText
                                primary={t("common.actions.delete")}
                                primaryTypographyProps={{
                                  style: { color: "#c62828" }
                                }}
                              />
                            </MenuItem>
                          </Menu>
                        </>
                      </HeroActionRail>
                      <AtaStatusChip ata={ata} status={ata.status} />
                    </HeroControls>
                  )}
                </HeroTop>
                {heroMinimized ? (
                  <HeroCompactMeta>
                    {heroCompactParts.join(" · ")}
                  </HeroCompactMeta>
                ) : (
                  <>
                    <MetaStrip>
                      <MetaItem>
                        <EventIcon />
                        <span>
                          {moment(ata.meetingAt || ata.createdAt).format(
                            "DD/MM/YYYY HH:mm"
                          )}
                        </span>
                      </MetaItem>
                      <MetaItem>
                        <HeadsetMicIcon />
                        <span>
                          {this.getEntryModeLabel(ata.entryMode) ||
                            ata.entryMode}
                          {ata.audioFileName ? ` · ${ata.audioFileName}` : ""}
                        </span>
                      </MetaItem>
                      <MetaItem>
                        <AtaParticipantsChip ata={ata} size="small" />
                      </MetaItem>
                    </MetaStrip>
                    {summary.turnsTotal > 0 && (
                      <VoiceProgressWrap
                        style={{ marginTop: 12, marginBottom: 0 }}
                      >
                        <VoiceProgressMeta>
                          <span>{t("smartMinutes.turnsConfirmedLabel")}</span>
                          <strong>
                            {summary.turnsLinked}
                            /
                            {summary.turnsTotal}
                            {" ("}
                            {turnsPct}
                            %)
                          </strong>
                        </VoiceProgressMeta>
                        <VoiceProgressTrack>
                          <VoiceProgressFill $pct={turnsPct} />
                        </VoiceProgressTrack>
                      </VoiceProgressWrap>
                    )}
                  </>
                )}
              </HeroCard>
            </HeaderCol>

            {hasAudio && (
              <AudioCol>
                <Group id="ata-audio-section">
                  <TitleRow>
                    <TitleCluster>
                      <SectionIcon>
                        <HeadsetMicIcon />
                      </SectionIcon>
                      <Heading level={2} gutterBottom={false}>
                        {t("smartMinutes.section.audio")}
                      </Heading>
                    </TitleCluster>
                    {this.renderSectionCollapseBtn("audio", {
                      expand: t("smartMinutes.audio.expand"),
                      collapse: t("smartMinutes.audio.collapse")
                    })}
                  </TitleRow>
                  {this.isSectionMinimized("audio") ? (
                    <SectionCompactMeta>
                      {[
                        ata.audioFileName || t("smartMinutes.list.audio"),
                        summary.turnsTotal
                          ? t("smartMinutes.speakersCompact.turnsLinked", {
                              linked: summary.turnsLinked,
                              total: summary.turnsTotal
                            })
                          : null
                      ]
                        .filter(Boolean)
                        .join(" · ")}
                    </SectionCompactMeta>
                  ) : (
                    <Box mt={1.5}>
                      {canPlayAudio ? (
                        <>
                          <AtaAudioPlayer
                            ataId={ata.id}
                            meetingId={ata.meetingId}
                            fileName={ata.audioFileName}
                            variant="full"
                            onTimeUpdate={this.onAudioTimeUpdate}
                          />
                          {this.renderLiveCaption()}
                          {this.renderSpeakerSelectMenu()}
                        </>
                      ) : (
                        <Typography color="textSecondary">
                          {t("smartMinutes.audio.metaMissingFile")}
                        </Typography>
                      )}
                    </Box>
                  )}
                </Group>
              </AudioCol>
            )}

            {hasSide && (
              <SideCol>
                {this.renderActionsPanel()}
                {this.renderSpeakers()}
              </SideCol>
            )}

            <MainCol>
              {hasTranscript && (
                <Group>
                  <TitleRow>
                    <TitleCluster>
                      <SectionIcon>
                        <DescriptionIcon />
                      </SectionIcon>
                      <Heading level={2} gutterBottom={false}>
                        {t("smartMinutes.section.transcript")}
                      </Heading>
                    </TitleCluster>
                    {this.renderSectionCollapseBtn("transcript", {
                      expand: t("smartMinutes.section.expandTranscript"),
                      collapse: t("smartMinutes.section.collapseTranscript")
                    })}
                  </TitleRow>
                  {this.isSectionMinimized("transcript") ? (
                    <SectionCompactMeta>
                      {[
                        summary.turnsTotal
                          ? t("smartMinutes.transcriptFilterAll", {
                              count: summary.turnsTotal
                            })
                          : t("smartMinutes.section.textAvailable"),
                        summary.turnsLinked
                          ? t("smartMinutes.transcriptFilterConfirmed", {
                              count: summary.turnsLinked
                            })
                          : null
                      ]
                        .filter(Boolean)
                        .join(" · ")}
                    </SectionCompactMeta>
                  ) : (
                    <Box mt={1.5}>{this.renderTranscript()}</Box>
                  )}
                </Group>
              )}
            </MainCol>
          </DetailLayout>
        </Grid>

        {this.renderAddParticipantDialog()}

        <Dialog
          open={confirmDelete}
          onClose={this.closeDeleteDialog}
          fullWidth
          maxWidth="sm"
        >
          <DialogTitle>{t("smartMinutes.delete.title")}</DialogTitle>
          <DialogContent>
            <Typography variant="body1" gutterBottom>
              {t("smartMinutes.delete.body")}
            </Typography>
            <Typography variant="body1" color="textSecondary" paragraph>
              {t("smartMinutes.delete.voicesNote")}
            </Typography>
            <TextField
              autoFocus
              fullWidth
              margin="normal"
              variant="outlined"
              label={t("smartMinutes.delete.confirmation")}
              placeholder={t("smartMinutes.delete.confirmWord")}
              helperText={t("smartMinutes.delete.helper")}
              value={deleteConfirmText}
              onChange={e =>
                this.setState({ deleteConfirmText: e.target.value })}
              disabled={deletingAta}
              InputLabelProps={{ shrink: true }}
              onKeyDown={e => {
                if (e.key === "Enter" && deleteConfirmed && !deletingAta) {
                  e.preventDefault();
                  this.onConfirmDelete();
                }
              }}
            />
          </DialogContent>
          <DialogActions>
            <Button
              variant="contained"
              color="secondary"
              onClick={this.closeDeleteDialog}
              disabled={deletingAta}
            >
              {t("common.actions.cancel")}
            </Button>
            <Button
              variant="contained"
              color="error"
              onClick={this.onConfirmDelete}
              disabled={!deleteConfirmed || deletingAta}
            >
              {deletingAta
                ? t("smartMinutes.delete.deleting")
                : t("common.actions.delete")}
            </Button>
          </DialogActions>
        </Dialog>
      </Grid>
    );
  }
}

SmartMinutesDetail.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
      studentId: PropTypes.string,
      ataId: PropTypes.string
    })
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func
  }).isRequired,
  alert: PropTypes.shape({
    show: PropTypes.func,
    error: PropTypes.func,
    success: PropTypes.func
  }).isRequired,
  t: PropTypes.func.isRequired
};

export default withAlert()(withRouter(withTranslation()(SmartMinutesDetail)));
